// Spanish translations - Primary language (complete)
const es = {
  // Navigation
  nav: {
    services: 'Servicios',
    about: 'Sobre Nosotros',
    blog: 'Blog',
    zones: 'Zonas',
    contact: 'Contacto',
    login: 'Iniciar Sesión',
    clientArea: 'Área Cliente',
    language: 'Idioma',
    home: 'Inicio',
    access: 'Acceder',
    search: 'Buscar en Punto Hispano',
    searchPlaceholder: '¿Qué estás buscando? Ej: seguros, habitación, desempleo...',
    noResults: 'No se encontraron resultados para',
    tryOther: 'Intenta con otros términos como "gestoría", "vivienda" o "seguros"',
    popularSearches: 'Búsquedas populares:',
    quickAccess: 'Accesos rápidos:',
    freeConsultation: 'Consulta Gratuita',
    allZones: 'Todas las Zonas',
    digitalBusiness: 'Emprende Digital',
    aboutUs: 'Sobre Nosotros',
    closeMenu: 'Cerrar menú',
    openMenu: 'Abrir menú',
  },

  // Hero Section
  hero: {
    title: 'Tu Gestoría en Español en Suiza',
    subtitle: 'Gestoría, asesoría legal, seguros, idiomas y soluciones digitales para hispanohablantes en Suiza.',
    cta: 'Consulta Gratis',
    ctaSecondary: 'Ver Servicios',
    trustBadge: '+2.500 familias confían en nosotros',
    experience: '+12 años de experiencia',
    act: 'ACTO I',
    actSubtitle: 'QUIENES SOMOS',
    titleLine1: 'GESTORÍA Y',
    titleLine2: 'ASESORÍA',
    titleLine3: 'EN SUIZA',
    cinematicSubtitle: 'Tu puente hacia el éxito en Suiza. Más de 12 años ayudando a hispanohablantes.',
    discoverServices: 'Descubrir Servicios',
    scheduleConsultation: 'Agendar Consulta',
  },

  // Services
  services: {
    title: 'Nuestros Servicios',
    subtitle: 'Todo lo que necesitas para vivir tranquilo en Suiza',
    gestoria: {
      name: 'Gestoría y Administración',
      description: 'Gestión integral de trámites: RAV, impuestos, permisos, CV, traducciones y asesoría legal.',
      cta: 'Consultar Servicios',
    },
    legal: {
      name: 'Asesoría Legal',
      description: 'Derecho de extranjería, laboral, familia, mercantil e inmobiliario.',
      cta: 'Consultar Legal',
    },
    seguros: {
      name: 'Seguros y Pensiones',
      description: 'Seguros de salud, vida, hogar, vehículos y planes de pensión.',
      cta: 'Cotización Gratis',
    },
    idiomas: {
      name: 'Cursos de Idiomas',
      description: 'Alemán e inglés para hispanohablantes. Niveles A1 a C1.',
      cta: 'Ver Cursos',
    },
    digital: {
      name: 'Soluciones Digitales',
      description: 'Diseño web, CRM, automatización con IA y marketing digital.',
      cta: 'Ver Portfolio',
    },
    relocation: {
      name: 'Pack Relocation',
      description: 'Todo lo que necesitas para mudarte a Suiza.',
      cta: 'Pack Completo',
    },
    vehiculos: {
      name: 'Alquiler de Vehículos',
      description: 'Alquiler de vehículos y furgonetas. Mudanzas.',
      cta: 'Ver Vehículos',
    },
    viviendas: {
      name: 'Alquiler de Viviendas',
      description: 'Pisos y habitaciones para corto y largo plazo.',
      cta: 'Ver Viviendas',
    },
    resultsTitle: 'RESULTADOS QUE',
    resultsTitleAccent: 'TRANSFORMAN',
    resultsSubtitle: 'Cada servicio resuelve un problema real que tú vives hoy.',
    viewAll: 'Ver todos los servicios',
    explore: 'Explorar',
    gestoriaShort: 'Gestoría',
    gestoriaDesc: 'Olvídate de colas y papeleos. Tus impuestos, permisos y trámites resueltos sin estrés.',
    gestoriaTags: 'Impuestos • Permisos • RAV',
    legalShort: 'Asesoría Legal',
    legalDesc: 'Protege tus derechos en un país donde no dominas las leyes. Duerme tranquilo.',
    legalTags: 'Contratos • Herencias • Visados',
    idiomasShort: 'Idiomas',
    idiomasDesc: 'Rompe la barrera del idioma. Consigue mejores trabajos y siéntete como en casa.',
    idiomasTags: 'Alemán • Inglés • Certificados',
    segurosShort: 'Seguros',
    segurosDesc: 'Ahorra hasta un 35% en primas sin perder cobertura. Tu familia protegida.',
    segurosTags: 'Salud • 3er Pilar • Vida',
    vehiculosShort: 'Alquiler de Coches',
    vehiculosDesc: 'Muévete con libertad desde el primer día. Sin complicaciones.',
    vehiculosTags: 'Turismos • Furgonetas • SUV',
    viviendasShort: 'Alquiler de Viviendas',
    viviendasDesc: 'Encuentra tu hogar sin competir con 200 candidatos. Acceso a pisos exclusivos.',
    viviendasTags: 'Habitaciones • Pisos • WG',
    digitalShort: 'Soluciones Digitales',
    digitalDesc: 'Multiplica tus ventas con una web profesional, CRM e IA que trabajan por ti.',
    digitalTags: 'Web • CRM • IA',
    relocationShort: 'Pack Relocation',
    relocationDesc: 'Llega a Suiza sin miedo. Todo resuelto antes de aterrizar.',
    relocationTags: 'Todo incluido',
    badgeBestSeller: 'Más vendido',
    badgeNew: 'Nuevo',
    badgeSave: 'Ahorra 25%',
    act: 'ACTO II',
    actSubtitle: 'SERVICIOS',
  },

  // Process
  process: {
    act: 'ACTO III',
    actSubtitle: 'PROCESO',
    title: 'DE TU PROBLEMA A',
    titleAccent: 'TU SOLUCIÓN',
    subtitle: 'Sin letra pequeña, sin complicaciones. Así de simple.',
    step1Title: 'Te Escuchamos',
    step1Desc: 'Cuéntanos qué te quita el sueño. Entendemos tu situación porque la hemos vivido.',
    step1Duration: 'Gratis',
    step2Title: 'Plan Sin Sorpresas',
    step2Desc: 'Sabrás exactamente qué hacemos, cuánto cuesta y cuándo lo tendrás resuelto.',
    step2Duration: '24-48h',
    step3Title: 'Nosotros Ejecutamos',
    step3Desc: 'Tú sigues con tu vida. Nosotros gestionamos, peleamos y resolvemos por ti.',
    step3Duration: 'Variable',
    step4Title: 'Problema Resuelto',
    step4Desc: 'No desaparecemos. Seguimos contigo hasta que todo esté 100% solucionado.',
    step4Duration: 'Continuo',
  },

  // About
  about: {
    title: 'Sobre Nosotros',
    subtitle: 'Conoce al equipo que hace posible Punto Hispano',
    mission: 'Nuestra misión es facilitar la vida de los hispanohablantes en Suiza.',
    heroTitle: '¿Quiénes somos?',
    heroSubtitle: 'Somos el puente entre tu idioma y la burocracia suiza. Desde 2013, ayudando a familias como la tuya.',
    stats: { families: 'Familias', procedures: 'Trámites', companies: 'Empresas', years: 'Años' },
    timeline: {
      t2013: { title: 'El Primer Paso', desc: 'Santiago llega a Suiza con una maleta y cero contactos. Nadie le explica cómo funcionan los impuestos, los seguros ni los permisos.' },
      t2019: { title: 'Crecimiento sin Fronteras', desc: 'Sin oficina pero con cientos de clientes. Punto Hispano ya es el nombre que la comunidad recomienda de boca en boca.' },
      t2023: { title: 'Nuestra Casa en Zúrich', desc: 'Abrimos oficina en Opfikon. Un espacio profesional donde recibir a nuestros clientes cara a cara.' },
      t2025: { title: 'Más de 2.500 Familias', desc: 'Equipo multidisciplinar: gestores, abogados, asesores de seguros, profesores de idiomas, desarrolladores.' },
    },
    valuesTitle: 'Nuestros Valores',
    values: {
      transparency: { title: 'Transparencia Total', desc: 'Sin letra pequeña ni sorpresas. Te decimos exactamente qué hacemos y cuánto cuesta.' },
      empathy: { title: 'Empatía Real', desc: 'Hemos estado en tu lugar. Sabemos lo que es sentirse perdido en otro país.' },
      results: { title: 'Resultados, No Palabras', desc: 'Nos medimos por problemas resueltos, no por promesas.' },
    },
  },

  // Contact
  contact: {
    title: 'Contacto',
    subtitle: '¿Tienes preguntas? Estamos aquí para ayudarte',
    name: 'Nombre',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    message: 'Mensaje',
    send: 'Enviar Mensaje',
    whatsapp: 'Escríbenos por WhatsApp',
    schedule: 'Agendar Consulta',
    address: 'Thurgauerstrasse 117, 1° Planta, Oficina 181, 8152 Opfikon, Zürich',
    heroTitle: '¿Cómo podemos ayudarte?',
    heroSubtitle: 'Estamos a un mensaje de distancia. Primera consulta gratuita.',
    officeTitle: 'Nuestra Oficina',
    hours: 'Horario: Lun-Vie 09:00-18:00',
    responseTime: 'Respondemos en menos de 2 horas',
    freeConsultation: 'Primera consulta 100% gratuita',
  },

  // Zones
  zones: {
    title: 'Zonas de Servicio',
    subtitle: 'Desde Zurich, para todo el mundo',
    description: 'Gestoría, asesoría legal, seguros y más para hispanohablantes en cualquier ubicación.',
    headquarters: 'Sede Principal',
    cities: 'ciudades',
    countriesTitle: 'Países con Mayor Presencia',
    notFound: '¿No encuentras tu zona?',
    notFoundDesc: 'No importa dónde estés, podemos ayudarte de forma online.',
    servicesIn: 'Servicios en',
    heroTitle: 'Donde Estés, Te Ayudamos',
    heroSubtitle: 'Servicios profesionales desde Zúrich para toda Europa y más allá.',
    europeTitle: 'Europa',
    allCountries: 'Ver todos los países',
    remoteServices: 'Servicios 100% online disponibles',
  },

  // Blog
  blog: {
    title: 'Blog',
    subtitle: 'Consejos, guías y noticias para la comunidad hispanohablante en Suiza',
    readMore: 'Leer más',
    readTime: 'min de lectura',
    categories: 'Categorías',
    search: 'Buscar artículos...',
  },

  // Footer
  footer: {
    description: 'Tu gestoría en español en Suiza',
    rights: 'Todos los derechos reservados',
    privacy: 'Política de Privacidad',
    cookies: 'Política de Cookies',
    legal: 'Aviso Legal',
    gdpr: 'GDPR',
    brandDesc: 'Tu socio integral en Suiza. Gestoría, legal, idiomas, seguros, viviendas, vehículos y soluciones digitales.',
    newsletter: 'Newsletter',
    newsletterDesc: 'Recibe novedades, consejos y ofertas exclusivas',
    subscribe: 'Suscribirse',
    emailPlaceholder: 'nombre@ejemplo.com',
    followUs: 'Síguenos en',
    servicesTitle: 'Servicios',
    gestoriaTitle: 'Gestoría',
    lifestyleTitle: 'Lifestyle',
    zonesTitle: 'Zonas',
    companyTitle: 'Empresa',
    legalTitle: 'Legal',
    zonesLink: 'Zonas de Servicio',
    madeWith: 'Desarrollado con ❤️ por',
    desempleo: 'Desempleo (RAV)',
    administracion: 'Administración',
    cvDoc: 'CV y Documentación',
    acompanamientos: 'Acompañamientos',
    traducciones: 'Traducciones',
    paquetes: 'Paquetes Especiales',
  },

  // Common
  common: {
    learnMore: 'Saber Más',
    viewAll: 'Ver Todos',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    close: 'Cerrar',
    loading: 'Cargando...',
    error: 'Ha ocurrido un error',
    retry: 'Reintentar',
    search: 'Buscar',
    noResults: 'Sin resultados',
    freeConsultation: 'Consulta Gratis',
    whatsapp: 'WhatsApp',
    schedule: 'Agendar Cita',
    callUs: 'Llámanos',
    from: 'Desde',
    our: 'Nuestros',
    all: 'Todos',
  },

  // Audience personalization
  audience: {
    trustLine: 'Más de 12 años ayudando a hispanohablantes en Suiza',
    empathy: '¿Te suena esto?',
    empathyItems: [
      'No entiendes las cartas oficiales que recibes',
      'Te sientes perdido con la burocracia suiza',
      'Necesitas ayuda con los impuestos',
      'Buscas alguien que te entienda en tu idioma',
    ],
    processTitle: 'Así de Fácil',
    processSteps: [
      { title: 'Cuéntanos tu caso', description: 'Contacta por WhatsApp o agenda una cita' },
      { title: 'Te asesoramos', description: 'Analizamos tu situación y te damos opciones' },
      { title: 'Resolvemos', description: 'Gestionamos todo por ti de forma profesional' },
    ],
  },

  // Navigation structure labels
  navStructure: {
    traditional: 'Tradicionales',
    lifestyle: 'Lifestyle',
    digital: 'Digitales',
    europe: 'Europa',
    america: 'América',
    other: 'Otros',
    viewAllZones: 'Ver todas las zonas',
    desempleo: 'Desempleo y RAV',
    administracion: 'Administración',
    cvDoc: 'CV y Documentación',
    traducciones: 'Traducciones',
    paquetes: 'Paquetes Especiales',
    extranjeria: 'Extranjería y Permisos',
    laboral: 'Derecho Laboral',
    familia: 'Derecho de Familia',
    mercantil: 'Derecho Mercantil',
    inmobiliario: 'Inmobiliario y Fiscal',
    aleman: 'Alemán',
    ingles: 'Inglés',
    seguroSalud: 'Seguro de Salud',
    vidaPension: 'Vida y Pensión',
    hogarVehiculos: 'Hogar y Vehículos',
    siniestros: 'Siniestros',
    comparador: 'Comparador',
    packBasico: 'Pack Básico',
    packCompleto: 'Pack Completo',
    paraEmpresas: 'Para Empresas',
    packRetorno: 'Pack Retorno',
    formacionIdiomas: 'Formación en Idiomas',
    segurosYPensiones: 'Seguros y Pensiones',
    alquilerVehiculos: 'Alquiler de Vehículos',
    alquilerViviendas: 'Alquiler de Viviendas',
    solucionesDigitales: 'Soluciones Digitales',
  },

  // Testimonials
  testimonials: {
    act: 'ACTO IV',
    actSubtitle: 'TESTIMONIOS',
    title: 'ELLOS YA VIVEN',
    titleAccent: 'SIN PREOCUPACIONES',
    subtitle: 'Historias reales de personas como tú que confiaron en nosotros',
    reviews: 'reseñas',
    viewReal: 'Ver reseñas reales en Google Maps',
    disclaimer: 'Las reseñas mostradas a continuación son representativas de la experiencia de nuestros clientes. Para ver nuestras reseñas auténticas y verificadas, visite nuestro perfil en Google Maps.',
  },

  // FAQ
  faq: {
    act: 'ACTO V',
    actSubtitle: 'FAQ',
    title: 'PREGUNTAS',
    titleAccent: 'FRECUENTES',
    subtitle: 'Todo lo que necesitas saber antes de dar el primer paso.',
    ctaText: '¿Tienes otra duda?',
    ctaLink: 'Contáctanos directamente',
    showMore: 'Ver más preguntas',
    showLess: 'Ver menos',
  },

  // Final CTA
  cta: {
    act: 'ACTO VI',
    actSubtitle: 'CONTACTO',
    urgencyBadge: 'Plazas limitadas — Solo 5 consultas gratuitas esta semana',
    title: 'NO ESPERES A QUE',
    titleAccent: 'SEA TARDE',
    subtitle: 'Cada día sin resolver tus trámites es un día de estrés innecesario. Da el primer paso ahora — es gratis.',
    step1Label: 'Selecciona servicio',
    step2Label: 'Datos',
    step3Label: 'Confirmación',
    stepTitle: '¿Qué servicio te interesa?',
    continueBtn: 'Continuar al paso 2',
    trustResponse: 'Te respondemos en menos de 24h',
    trustFamilies: '+2500 familias ya lo resolvieron',
    trustLanguage: '100% en tu idioma, sin barreras',
    serviceOther: 'Otro / No estoy seguro',
  },

  // Trust Logos
  trust: {
    headline: '+2,500 hispanohablantes ya dejaron de preocuparse por la burocracia suiza',
    verifiedLabel: 'Empresas verificadas:',
    dataProtected: 'Datos 100% protegidos',
    dataProtectedSub: 'Tu información es sagrada',
    registered: 'Empresa registrada en Suiza',
    registeredSub: 'Verificable en Moneyhouse',
    realOffice: 'Oficina real en Zürich',
    realOfficeSub: 'No somos un buzón',
    experience: '12+ años, 2500+ familias',
    experienceSub: 'Resultados comprobables',
  },

  // Home FAQ content
  homeFaq: {
    questions: [
      { question: 'Acabo de llegar a Suiza y no sé por dónde empezar. ¿Me pueden ayudar?', answer: 'Absolutamente. Sabemos lo abrumador que es llegar a un país nuevo con idioma, leyes y burocracia diferentes. Nuestro Pack Relocation cubre todo: permisos, seguros, banco, vivienda y más. Un coordinador personal te guía paso a paso para que no tengas que descifrar nada solo.' },
      { question: '¿Cuánto me cuesta la primera consulta? ¿Hay compromiso?', answer: 'La primera consulta es 100% gratuita y sin compromiso. En 15 minutos escuchamos tu caso, entendemos qué necesitas y te explicamos cómo podemos ayudarte. Si decides no continuar, no pasa nada. Cero presión.' },
      { question: 'Estoy pagando demasiado en impuestos. ¿Pueden optimizar mi declaración?', answer: 'Es lo que mejor hacemos. En 12+ años hemos recuperado miles de francos para nuestros clientes con deducciones que no conocían. Preparamos tu declaración completa, optimizamos legalmente tu carga fiscal y te representamos ante las autoridades si es necesario.' },
      { question: 'Tengo un problema legal y no entiendo las leyes suizas. ¿Qué hago?', answer: 'No estás solo. Nuestros asesores legales hablan tu idioma y conocen la ley suiza al detalle. Contratos laborales, reagrupación familiar, herencias, permisos — te protegemos y defendemos tus derechos para que duermas tranquilo.' },
      { question: 'Necesito aprender alemán pero los cursos convencionales no me funcionan.', answer: 'Porque no están diseñados para hispanohablantes. Nuestra metodología parte de las dificultades específicas del español al alemán. Cursos de A1 a C1, presenciales en Zürich u online. Profesores certificados que entienden cómo aprendes.' },
      { question: '¿Cómo sé si estoy pagando de más por mi seguro médico?', answer: 'Probablemente sí — el 70% de nuestros clientes ahorra un promedio de 35% después de nuestra comparación gratuita. Analizamos tus primas, franquicias y coberturas, y gestionamos el cambio completo sin que tengas que hacer nada.' },
      { question: '¿Solo atienden en Zürich o también a distancia?', answer: 'Nuestra oficina está en Opfikon (Zürich), pero atendemos clientes de toda Suiza y del extranjero. El 80% de nuestros servicios son 100% online. No importa dónde estés — la distancia no es excusa para seguir con problemas sin resolver.' },
      { question: '¿Por qué debería confiar en Punto Hispano y no en otro gestor?', answer: 'Porque somos empresa registrada y verificable en Moneyhouse (Gestoría GmbH, Immobilien GmbH, Holding GmbH). Más de 2,500 familias nos han elegido. 4.9 estrellas en Google. Y lo más importante: hablamos tu idioma y entendemos tu realidad porque la hemos vivido.' },
    ],
    additionalQuestions: [
      { question: '¿Dónde están exactamente? ¿Puedo ir a la oficina?', answer: 'Sí, estamos en Thurgauerstrasse 117, 8152 Opfikon, Zürich (1° Planta, Oficina 181). Lunes a viernes 9:00-18:00, sábados con cita previa. Ven a conocernos — somos personas reales, no un formulario online.' },
      { question: 'Quiero asegurar mi jubilación. ¿Qué opciones tengo con el 3er Pilar?', answer: 'El 3er Pilar es la mejor herramienta para asegurar tu futuro Y ahorrar en impuestos hoy. Comparamos todas las opciones del mercado (3a y 3b), optimizamos tu estrategia fiscal y gestionamos traspasos. Cada año que esperas, pierdes dinero.' },
      { question: 'Mi negocio necesita presencia digital. ¿Pueden ayudar?', answer: 'Diseñamos webs que venden, no que solo existen. CRM personalizados, automatización con IA, marketing digital y SEO. Nuestros clientes duplican su captación online en los primeros 3 meses.' },
      { question: 'Necesito un coche pero no quiero complicaciones con contratos largos.', answer: 'Alquiler flexible: desde días hasta meses. Utilitarios, SUVs y furgonetas. Seguro a todo riesgo incluido, atención en español y asistencia 24/7. Muévete con libertad sin ataduras.' },
      { question: 'Encontrar piso en Suiza es imposible. ¿De verdad pueden ayudarme?', answer: 'Sabemos lo frustrante que es. Tenemos acceso a una red exclusiva de propietarios, gestionamos visitas, negociamos condiciones y te acompañamos hasta la firma. No compites solo — compites con ventaja.' },
      { question: '¿Qué incluye exactamente el Pack Relocation?', answer: 'TODO: búsqueda de vivienda, apertura de cuenta bancaria, registro municipal, seguros obligatorios, CV adaptado al mercado suizo, cursos de alemán, orientación escolar para tus hijos y un coordinador personal. Ahorras un 25% vs. contratar cada servicio por separado.' },
      { question: '¿Cómo pago? ¿Aceptan pagos fraccionados?', answer: 'Transferencia, tarjeta, TWINT o PayPal. Y sí, ofrecemos fraccionamiento para servicios de mayor importe. No queremos que el dinero sea un obstáculo para resolver tus problemas.' },
      { question: 'No tengo permiso de residencia todavía. ¿Pueden ayudarme igual?', answer: 'Sí. Ayudamos a regularizar situaciones migratorias y asesoramos sobre las mejores vías para obtener tu permiso. Cuanto antes actúes, más opciones tienes. No esperes a que sea un problema mayor.' },
    ],
  },

  seo: {
    homeTitle: 'Punto Hispano | Gestoría en Español en Suiza',
    homeDescription: 'Mejor Gestoría y Asesoría en Zürich para hispanohablantes en Suiza. Fiscalidad, legal, seguros, alemán, relocation, alquileres y soluciones digitales.',
  },

  // Services Index Page
  servicesIndex: {
    heroTitle: 'Todos Nuestros Servicios',
    heroSubtitle: 'Tu solución integral en Suiza. Desde trámites administrativos hasta soluciones digitales avanzadas.',
    heroCta: 'Consulta Gratis por WhatsApp',
    categories: {
      gestoria: {
        title: 'Gestoría y Administración',
        description: '¿Otro año rezando para que Hacienda no te pille un error? Nosotros nos encargamos de todo: impuestos, RAV, permisos. Tú solo recibes el resultado.',
        cta: 'Quiero dejar de preocuparme',
        features: ['Declaración sin errores', 'Permisos al día', 'Sin colas ni estrés', 'Ahorro fiscal real'],
      },
      legal: {
        title: 'Asesoría Legal',
        description: 'Un contrato que no entiendes puede costarte miles de francos. Nuestros abogados hablan tu idioma y defienden TUS derechos.',
        cta: 'Proteger mis derechos',
        features: ['Contratos revisados', 'Permisos resueltos', 'Reagrupación familiar', 'Tranquilidad legal'],
      },
      idiomas: {
        title: 'Formación en Idiomas',
        description: 'Sin idioma, no hay trabajo. Sin trabajo, no hay futuro aquí. Nuestros cursos están diseñados para que hables, no para que memorices gramática.',
        cta: 'Empezar a hablar',
        features: ['Profesores nativos', 'Niveles A1-C1', 'Grupos reducidos', 'Certificados oficiales'],
      },
      seguros: {
        title: 'Seguros y Pensiones',
        description: 'Cada año pierdes cientos de francos por no comparar. Te encontramos el mejor seguro al mejor precio, sin que pierdas cobertura.',
        cta: 'Comparar y ahorrar',
        features: ['Hasta 35% ahorro', 'Asesor personal', 'Todas las compañías', 'Sin compromiso'],
      },
      digital: {
        title: 'Soluciones Digitales',
        description: 'Tu competencia ya tiene web, CRM y automatizaciones. ¿Y tú? Llevamos tu negocio al siguiente nivel.',
        cta: 'Ver lo que podemos hacer',
        features: ['Web profesional', 'CRM personalizado', 'IA y automatización', 'Marketing digital'],
      },
      vehiculos: {
        title: 'Alquiler de Vehículos',
        description: 'Muévete con libertad. Coches, furgonetas y SUV para mudanzas, vacaciones o el día a día.',
        cta: 'Ver vehículos',
        features: ['Sin depósito excesivo', 'Seguro incluido', 'Recogida flexible', 'Precios competitivos'],
      },
      viviendas: {
        title: 'Alquiler de Viviendas',
        description: 'Encuentra tu hogar sin competir con 200 candidatos. Habitaciones y pisos verificados.',
        cta: 'Buscar vivienda',
        features: ['Verificados', 'Sin comisión oculta', 'Corta y larga estancia', 'Zonas céntricas'],
      },
      relocation: {
        title: 'Pack Relocation',
        description: 'Llega a Suiza con todo resuelto. Vivienda, permisos, seguros, cuenta bancaria: todo en un pack.',
        cta: 'Quiero llegar tranquilo',
        features: ['Todo incluido', 'Asesor personal', 'Antes de llegar', 'Garantía de resultado'],
      },
    },
  },

  // About Us Page
  aboutPage: {
    seoTitle: 'Sobre Punto Hispano — Gestoría para Hispanohablantes en Suiza',
    seoDesc: 'Conoce a Punto Hispano: 12+ años ayudando a hispanohablantes en Suiza.',
    heroSub: 'Sobre Punto Hispano — Gestoría para Hispanohablantes en Suiza',
    heroTitle1: 'La Gestoría de Confianza',
    heroTitle2: 'para ',
    heroTitle3: 'Hispanohablantes',
    heroTitle4: 'en Suiza',
    heroDesc: 'Llegamos a Suiza como tú. Sabemos lo que se siente no entender una carta de Hacienda, firmar un contrato a ciegas, o buscar colegio sin hablar el idioma. Por eso creamos Punto Hispano: para que nadie más pase por eso solo.',
    knowServices: 'Conoce Nuestros Servicios →',
    talkToUs: 'Habla con Nosotros',
    originTitle: 'No Creamos una Empresa. Resolvimos un Problema que Vivimos en Carne Propia.',
    originP1: 'En 2013, Santiago Castillo se enfrentó a lo mismo que tú: un país nuevo, un idioma que no dominaba, y un sistema que nadie le explicó. Buscó ayuda en español y no la encontró. Así que decidió crearla.',
    originP2: 'Hoy, Punto Hispano no es solo una gestoría. Es el lugar donde +2.500 familias hispanohablantes han encontrado a alguien que habla su idioma, entiende su cultura, y pelea por sus derechos como si fueran propios.',
    originP3: 'No somos una empresa que ofrece servicios. Somos personas que resolvieron el mismo problema que tú tienes ahora.',
    originBadge: '🇨🇭 Desde Zúrich, para toda la comunidad hispanohablante en Suiza',
    timelineTitle: '12 Años Creciendo Contigo',
    founderTag: 'Fundador',
    founderName: 'Santiago Castillo',
    founderQuote: '"Llegué a Suiza con una maleta y cero contactos. Nadie me explicó cómo funcionaban los impuestos, los seguros, ni los permisos. Busqué ayuda en español y no existía. Así que la creé yo."',
    founderDesc: 'Hoy, más de 12 años después, Punto Hispano es el referente de la comunidad hispanohablante en Suiza. Porque cuando entiendes el problema porque lo has vivido, la solución es real.',
    founderExp: 'Más de 12 años de experiencia',
    teamTitle: 'Un Equipo Completo a Tu Servicio',
    teamSubtitle: 'No te mandamos de un sitio a otro. Todo bajo un mismo techo.',
    teamStats: [
      { number: '8+', text: 'Profesionales en plantilla', sub: 'Gestores, abogados, asesores de seguros, profesores de idiomas' },
      { number: '100%', text: 'Equipo hispanohablante', sub: 'Nos entendemos sin traductores. Hablamos tu idioma y tu cultura.' },
      { number: '5+', text: 'Áreas de especialización', sub: 'Gestoría, legal, seguros, idiomas, digital, relocation' },
    ],
    missionTitle: 'Nuestra Misión',
    missionWhat: 'Lo Que Hacemos Cada Día',
    missionWhatDesc: 'Resolver los problemas reales de los hispanohablantes en Suiza. No vendemos servicios genéricos: escuchamos tu situación, la entendemos porque la hemos vivido, y la resolvemos con profesionalidad y cercanía.',
    missionWhere: 'Hacia Dónde Vamos',
    missionWhereDesc: 'Que ningún hispanohablante en Suiza se sienta solo ante un problema. Queremos ser la primera llamada que hagas cuando algo te preocupe.',
    allServices: 'Todo lo que Punto Hispano Puede Hacer por Ti',
    allServicesSub: 'Más de 20 soluciones específicas para hispanohablantes en Suiza.',
    commitmentsTitle: 'Tres Compromisos que Cumplimos Siempre',
    commitments: [
      { title: 'Respuesta en Menos de 2 Horas', desc: 'En horario laboral, te respondemos en un máximo de 2 horas.', proof: 'Compromiso verificable' },
      { title: 'Primera Consulta Gratis', desc: 'Nos sentamos contigo, escuchamos tu situación y te damos un diagnóstico claro.', proof: '100% gratuita' },
      { title: '4.9★ en Google', desc: 'Más de 2.500 familias nos han elegido y nos recomiendan.', proof: 'Valoración real de clientes' },
    ],
    joinTitle: '¿Quieres Formar Parte del Equipo?',
    joinDesc: 'Buscamos profesionales hispanohablantes apasionados por ayudar a su comunidad en Suiza.',
    joinCta: '✉️ Envíanos tu CV →',
    finalTitle: '¿Tienes un Problema en Suiza? Cuéntanoslo.',
    finalDesc: 'No tienes que resolverlo todo solo/a. Da el primer paso y te ayudamos.',
    finalCta: 'Agendar Consulta Gratis →',
    finalServices: 'Ver Todos los Servicios →',
  },

  // Zones Index Page
  zonesPage: {
    seoTitle: 'Nos encuentras desde cualquier país | Punto Hispano · Suiza + 57 países',
    seoDesc: 'Gestoría, legal, seguros, idiomas y soluciones digitales para hispanohablantes en más de 57 países. 100% online desde Opfikon (Zurich), en 6 idiomas y en tu franja horaria.',
    heroTitle: 'Estés donde estés, te atendemos',
    heroSubtitle: 'Desde Opfikon (Zurich) para todo el mundo. Más de 57 países, 210+ ciudades, 6 idiomas nativos y respuesta en menos de 2 horas en tu huso horario.',
    hq: 'Sede Principal',
    switzerland: 'Suiza',
    switzerlandDesc: 'Con oficina en Opfikon (Zurich), atendemos a toda la comunidad hispanohablante en Suiza.',
    countriesTitle: 'Países con Mayor Presencia',
    countriesSubtitle: 'Encuentra nuestros servicios en Suiza, España, Italia y Latinoamérica.',
    cities: 'ciudades',
    notFoundTitle: '¿No encuentras tu zona?',
    notFoundDesc: 'No importa dónde estés, podemos ayudarte de forma online. Contáctanos y te atenderemos como si estuvieras en nuestra oficina de Zurich.',
    whatsappCta: 'Contactar por WhatsApp',
    scheduleCta: 'Agendar Consulta',
  },

  // Blog Page
  blogPage: {
    seoTitle: 'Blog Punto Hispano | Guías para Hispanohablantes en Suiza',
    seoDesc: 'Guías sobre impuestos, permisos, seguros y vida en Suiza. Explicado en español, sin tecnicismos.',
    heroTitle: 'Blog de Punto Hispano — ',
    heroTitleAccent: 'Guías y Consejos para Hispanohablantes en Suiza',
    heroDesc: 'Todo lo que necesitas saber para vivir, trabajar y prosperar en Suiza. Explicado en español, sin tecnicismos, con ejemplos reales.',
    all: 'Todos',
    readArticle: 'Leer artículo',
    readTime: 'min de lectura',
    noArticles: 'No hay artículos disponibles en esta categoría.',
    newsletterTitle: '📬 Recibe Nuestros Artículos en tu Email',
    newsletterDesc: 'Un email a la semana con lo que necesitas saber para vivir tranquilo en Suiza. Sin spam, solo contenido útil.',
    emailPlaceholder: 'Tu email...',
    subscribe: 'Suscribirme',
    noSpam: '🔒 Sin spam. Cancelar cuando quieras.',
  },

  // Blog Post (article detail page)
  blogPost: {
    home: 'Inicio',
    blog: 'Blog',
    author: 'Equipo Punto Hispano',
    minRead: 'min de lectura',
    needHelpMobileTitle: '¿Necesitas Ayuda con Esto?',
    needHelpMobileDesc: 'Primera consulta gratuita. Nuestro equipo puede resolver esto por ti.',
    scheduleConsult: 'Agendar Consulta →',
    endCtaTitle: '¿Quieres que Nos Encarguemos de Esto por Ti?',
    endCtaDesc: 'No tienes que hacerlo solo/a. Agenda tu consulta gratuita y te explicamos exactamente cómo podemos ayudarte.',
    endCtaButton: 'Agendar Consulta Gratuita →',
    endCtaResponse: '⏰ Respuesta en menos de 2 horas en horario laboral',
    keepReading: 'Sigue leyendo',
    backToBlog: 'Volver al Blog',
    sidebarHelpTitle: '¿Necesitas Ayuda?',
    sidebarHelpDesc: 'Primera consulta gratuita. Nuestro equipo puede resolver esto por ti.',
    relatedArticles: 'Artículos relacionados',
    mobileStickyCta: 'Consulta gratuita',
  },

  // Zones Detail Pages (Country + City)
  zonesDetail: {
    // SEO
    seoTitleCountry: 'Servicios en {country} | Punto Hispano - Atención desde Zurich',
    seoDescCountry: 'Gestoría, asesoría legal, seguros e idiomas para hispanohablantes en {country}. Atención presencial y online desde Opfikon, Zurich.',
    seoTitleCity: 'Servicios en {city}, {country} | Punto Hispano',
    seoDescCity: 'Gestoría, asesoría legal, seguros y más para hispanohablantes en {city}. Atención presencial y online desde Opfikon, Zurich.',
    // Country page
    citiesIn: 'Ciudades en {country}',
    findYourCity: 'Encuentra tu ciudad y descubre todos los servicios disponibles.',
    cities: 'ciudades',
    featured: '★ Destacada',
    noZones: 'No hay zonas disponibles en este país actualmente.',
    contactAnyway: 'Contactar de todas formas',
    dontSeeCity: '¿No ves tu ciudad?',
    dontSeeCityDesc: 'Da igual donde estés en {country}, te atendemos de forma online desde Zurich.',
    contactWhatsApp: 'Contactar por WhatsApp',
    allZones: 'Todas las zonas',
    // City page
    servicesForIn: 'Servicios para Hispanohablantes en {city}',
    servicesFullDesc: 'En Punto Hispano, ofrecemos una gama completa de servicios para la comunidad hispanohablante en {city}. Desde gestoría y administración hasta asesoría legal, seguros, cursos de idiomas y soluciones digitales. Nuestra oficina principal está en Opfikon (Zurich), pero te atendemos de forma online estés donde estés.',
    needHelpIn: '¿Necesitas ayuda en {city}?',
    remoteAttention: 'Aunque estés en {city}, te atendemos como si estuvieras en nuestra oficina de Zurich. Contáctanos hoy.',
    officeOpfikon: 'Oficina en Opfikon, Suiza',
    inPersonAndOnline: 'Atención presencial y online',
    scheduleConsultation: 'Agendar Consulta',
    otherCitiesIn: 'Otras ciudades en {country}',
    exploreMore: 'Explora más zonas donde ofrecemos nuestros servicios.',
    viewAllCitiesIn: 'Ver todas las ciudades en {country}',
    backTo: 'Volver a {country}',
    // Services showcase
    allServices: 'Todos Nuestros Servicios',
    servicesIn: 'Servicios en {zone}',
    availableFromOffice: 'Disponibles de forma presencial y online desde nuestra oficina en Opfikon, Zurich.',
    viewMore: 'Ver más',
    mainOffice: 'Oficina Principal',
    onlineConsultation: 'Consulta Online',
    // Service names
    serviceGestoria: 'Gestoría',
    serviceGestoriaDesc: 'Impuestos, permisos, RAV',
    serviceLegal: 'Asesoría Legal',
    serviceLegalDesc: 'Contratos, visados, herencias',
    serviceLanguages: 'Idiomas',
    serviceLanguagesDesc: 'Alemán, inglés, certificados',
    serviceInsurance: 'Seguros',
    serviceInsuranceDesc: 'Salud, vida, 3er pilar',
    serviceCarRental: 'Alquiler Coches',
    serviceCarRentalDesc: 'Turismos, furgonetas',
    serviceHousing: 'Viviendas',
    serviceHousingDesc: 'Habitaciones, pisos, WG',
    serviceDigital: 'Digital',
    serviceDigitalDesc: 'Web, CRM, IA, automatización',
    serviceRelocation: 'Pack Relocation',
    serviceRelocationDesc: 'Todo incluido para llegar',
    // Remote process
    howWeHelp: 'Cómo Te Ayudamos',
    remotely: 'a Distancia',
    remoteDesc: 'Aunque estés en {city}, te atendemos como si estuvieras en nuestra oficina de Zurich.',
    remoteDescGeneral: 'Desde Zurich, para todo el mundo. Atención profesional sin importar tu ubicación.',
    step1Title: 'Contacta con Nosotros',
    step1Desc: 'Escríbenos por WhatsApp, email o llámanos. Respuesta en menos de 24h.',
    step2Title: 'Consulta Online',
    step2Desc: 'Agendamos una videollamada para entender tu situación y necesidades.',
    step3Title: 'Resolución',
    step3Desc: 'Gestionamos todo de forma remota. Tú solo firmas los documentos necesarios.',
    benefit1: 'Respuesta en 24h',
    benefit2: '+12 años experiencia',
    benefit3: 'Atención multilingüe',
    // Breadcrumb
    home: 'Inicio',
    zones: 'Zonas',
    // Gestoria description for ServiceSchema
    gestoriaAndAdvice: 'Gestoría y Asesoría en {city}',
    professionalServices: 'Servicios profesionales para hispanohablantes en {city}',
    servicesDescription: 'Servicios de gestoría, asesoría legal, seguros y más para hispanohablantes en {country}. Te atendemos desde nuestra oficina en Zurich.',
  },

  // Gestoría Landing Page
  gestoriaPage: {
    seoTitle: 'Gestoría para Hispanohablantes en Suiza | Trámites, Impuestos, RAV | Punto Hispano',
    seoDesc: 'Gestoría en español en Suiza. Inscripción RAV, declaración de impuestos, traducciones oficiales, creación de empresas. Más de 12 años de experiencia.',
    heroTitle: 'Gestoría para Hispanohablantes en Suiza',
    heroAccent: '— Trámites, Impuestos y RAV en Español',
    heroDesc: '¿Otro año sin entender tu declaración de impuestos? ¿Cartas del RAV que no sabes contestar? Nosotros nos encargamos de todo. Tú solo recibes el resultado.',
    heroCta: 'Ver Todos los Servicios ↓',
    heroWhatsapp: 'Consulta Gratuita por WhatsApp',
    badge1: '+2.500 familias',
    badge2: 'Respuesta < 2h',
    badge3: '12+ años',
    empathyTitle: '¿Te Suena Alguna de Estas Situaciones?',
    empathy1: 'Llega el plazo de la declaración y no entiendes ni la primera línea',
    empathy2: 'Recibes cartas en alemán del RAV y no sabes qué te están pidiendo',
    empathy3: 'Necesitas renovar tu permiso y tienes miedo de que te lo rechacen',
    empathy4: 'Quieres abrir una empresa pero el papeleo suizo te paraliza',
    empathyBottom: 'Si te identificas con alguna, estás en el sitio correcto.',
    categoriesTitle: '¿Qué Necesitas Resolver?',
    categoriesDesc: 'Elige tu situación y te mostramos exactamente cómo podemos ayudarte.',
    packagesTitle: 'Paquetes Todo-en-Uno',
    packagesDesc: 'Soluciones completas para situaciones concretas.',
    requestPack: 'Solicitar Pack',
    processTitle: 'Así de Fácil',
    step1Title: 'Cuéntanos tu caso',
    step1Desc: 'Escríbenos por WhatsApp o rellena el formulario',
    step2Title: 'Recibe tu plan',
    step2Desc: 'Te decimos qué necesitas y cuánto cuesta',
    step3Title: 'Nosotros nos encargamos',
    step3Desc: 'Tú nos das los docs, nosotros hacemos el resto',
    ctaTitle: '¿No Sabes Qué Servicio Necesitas?',
    ctaDesc: 'Cuéntanos tu situación y te decimos exactamente qué necesitas. Gratis y sin compromiso.',
    ctaWhatsapp: 'Consulta Gratis por WhatsApp',
    ctaSchedule: 'Agendar Llamada',
    faqTitle: 'Preguntas Frecuentes',
    faq1Q: '¿Cuánto cuesta la inscripción al RAV?',
    faq1A: 'Escríbenos por WhatsApp o rellena nuestro formulario de contacto y te enviamos un presupuesto personalizado en menos de 2 horas. El Pack Inscripción RAV incluye toda la documentación, CV formato suizo, carta de presentación, alta en JOB-room y acompañamiento a tu primera cita presencial.\n\n⚠️ Recuerda: debes inscribirte ANTES de tu primer día sin trabajo.',
    faq2Q: '¿Cómo puedo hacer mi declaración de impuestos?',
    faq2A: 'Puedes hacerla tú mismo o contratar nuestro servicio de declaración de impuestos. Nos encargamos de revisar tu situación completa, aplicar TODAS las deducciones posibles y presentarla en plazo.\n\n⚠️ Plazo: en la mayoría de cantones, la fecha límite es el 31 de marzo.',
    faq3Q: '¿La primera consulta es gratis?',
    faq3A: 'Sí. Ofrecemos una primera consulta gratuita de 15 minutos donde escuchamos tu caso e identificamos qué necesitas. Puedes venir a nuestra oficina en Opfikon, llamarnos o escribirnos por WhatsApp. Sin compromiso.',
    faqMore: '¿Más preguntas? Contáctanos →',
    reviewsTitle: 'Lo Que Dicen Nuestros Clientes',
    reviewsDesc: 'Experiencias reales de familias hispanohablantes',
    reviewsMore: 'Ver todas las reseñas en Google →',
    crossSellTitle: 'Descubre Nuestros Otros Servicios',
    crossSellDesc: 'Todo lo que un hispanohablante necesita en Suiza, bajo un mismo techo.',
    finalTitle: 'Deja de Preocuparte. Empieza Hoy.',
    finalDesc: 'Cada día que pasa sin resolver tu trámite es un día más de estrés.',
    finalCta: 'Consulta Gratuita por WhatsApp',
    finalBack: 'Ver Servicios ↑',
  },

  // Legal Landing Page
  legalPage: {
    seoTitle: 'Abogado Español en Suiza · Asesoría Legal en Español Zúrich | Punto Hispano',
    seoDesc: 'Abogados que hablan español en Suiza: extranjería, laboral, familia, mercantil e inmobiliario. Primera consulta 10 min gratis. Atención en Zúrich y toda Suiza.',
    heroTitle: 'Asesoría Legal para Hispanohablantes en Suiza',
    heroAccent: '— Permisos, Laboral, Familia y Empresas en Español',
    heroDesc: 'Problemas con tu permiso, despido injusto, divorcio, deudas... No tienes por qué resolverlo solo/a. Te asesoramos en español con especialistas en derecho suizo.',
    heroCta: 'Ver Áreas de Práctica ↓',
    heroWhatsapp: 'Consulta Gratuita por WhatsApp',
    badge1: '+2.500 familias',
    badge2: 'Respuesta < 2h',
    badge3: '12+ años',
    empathyTitle: '¿Te Suena Alguna de Estas Situaciones?',
    empathy1: 'Te han despedido y crees que es injusto pero no sabes qué hacer',
    empathy2: 'Estás en proceso de divorcio y no entiendes la ley suiza',
    empathy3: 'Te han denegado el permiso y no sabes cómo recurrir',
    empathy4: 'Tu casero te ha subido el alquiler y no sabes si es legal',
    empathyBottom: 'Si te identificas con alguna, estás en el sitio correcto.',
    categoriesTitle: 'Nuestras Áreas de Práctica Legal',
    categoriesDesc: 'Elige tu situación y te mostramos cómo podemos ayudarte.',
    cat1Name: 'Extranjería y Permisos',
    cat1Desc: 'Permisos B, C, G, renovaciones, reagrupación familiar, recurso por denegación, nacionalidad suiza.',
    cat1Badge: '7 servicios disponibles',
    cat2Name: 'Derecho Laboral',
    cat2Desc: 'Despidos, contratos, reclamaciones, mobbing, certificados de trabajo, horas extra, empresa en quiebra.',
    cat2Badge: '8 servicios disponibles',
    cat3Name: 'Derecho de Familia',
    cat3Desc: 'Divorcios, custodia, pensiones alimenticias, separación de bienes, mediación, reagrupación de hijos.',
    cat3Badge: '7 servicios disponibles',
    cat4Name: 'Derecho Mercantil y Empresas',
    cat4Desc: 'Constitución de empresas, contratos, disputas entre socios, cobro de deudas, reclamaciones a seguros.',
    cat4Badge: '6 servicios disponibles',
    cat5Name: 'Inmobiliario y Fiscal',
    cat5Desc: 'Compraventa, alquileres, disputas con propietarios, optimización fiscal, recursos tributarios.',
    cat5Badge: '6 servicios disponibles',
    viewServices: 'Ver servicios →',
    ctaTitle: '¿No Sabes Qué Área Legal Necesitas?',
    ctaDesc: 'Cuéntanos tu situación y te orientamos gratis. Sin compromiso.',
    ctaWhatsapp: 'Consulta Gratis por WhatsApp',
    ctaSchedule: 'Agendar Llamada',
    processTitle: 'Así de Fácil',
    step1: 'Cuéntanos tu caso',
    step2: 'Recibe tu plan legal',
    step3: 'Nosotros nos encargamos',
    faqTitle: 'Preguntas Frecuentes',
    faqMore: 'Ver más preguntas →',
    reviewsTitle: 'Lo Que Dicen Nuestros Clientes',
    crossSellTitle: 'Descubre Nuestros Otros Servicios',
    crossSellDesc: 'Todo lo que un hispanohablante necesita en Suiza, bajo un mismo techo.',
    finalTitle: '¿Necesitas Asesoramiento Legal?',
    finalDesc: 'Primera consulta gratuita con nuestros especialistas en derecho suizo.',
    finalCta: 'Solicitar Consulta Gratuita',
  },

  // Idiomas Landing Page
  idiomasPage: {
    seoTitle: 'Formación en Idiomas para Hispanohablantes en Suiza | Punto Hispano',
    seoDesc: 'Cursos de alemán e inglés diseñados para hispanohablantes. Clases presenciales y online en Zürich.',
    heroTitle: 'Formación en Idiomas para Hispanohablantes en Suiza',
    heroAccent: '— Alemán, Inglés y Certificaciones Oficiales',
    heroDesc: 'De las mejores escuelas en Zürich con metodología diseñada para hispanohablantes. Aprende más rápido, con menos frustración, y certifícate con garantía.',
    heroCta: 'Ver Cursos ↓',
    badge1: '+450 estudiantes',
    empathyTitle: '¿Te Suena Alguna de Estas Situaciones?',
    empathy1: 'No entiendes nada en la oficina y todo es en alemán',
    empathy2: 'Necesitas el B1 para el permiso C y no sabes por dónde empezar',
    empathy3: 'Tu jefe te pide inglés profesional y te bloqueas en las reuniones',
    empathy4: 'Quieres certificarte pero los exámenes oficiales te asustan',
    empathyBottom: 'Si te identificas con alguna, estás en el sitio correcto.',
    coursesTitle: '¿Qué Quieres Aprender?',
    coursesDesc: 'Elige tu objetivo y te mostramos el camino más rápido para lograrlo.',
    germanTitle: 'Cursos de Alemán',
    germanDesc: 'Presencial y online. Clases grupales y privadas. Desde A1 hasta C1, con metodología adaptada a hispanohablantes.',
    germanBadge: 'Presencial · Online · Privado',
    germanCta: 'Ver cursos de alemán →',
    englishTitle: 'Cursos de Inglés',
    englishDesc: 'Presencial y online. Clases grupales y privadas. Business English, conversación y preparación de certificaciones.',
    englishBadge: 'Presencial · Online · Privado',
    englishCta: 'Ver cursos de inglés →',
    processTitle: 'Así de Fácil',
    step1Title: 'Haz tu test de nivel',
    step1Desc: 'Evaluamos tu nivel actual en una llamada de clase o directamente con nuestro formulario',
    step2Title: 'Elige tu curso',
    step2Desc: 'Te recomendamos el programa ideal para tus objetivos',
    step3Title: 'Empieza a hablar',
    step3Desc: 'Desde la primera clase practicas conversación real',
    ctaTitle: '¿No Sabes Qué Curso Necesitas?',
    ctaDesc: 'Haz tu test de nivel gratuito y te recomendamos el programa perfecto para ti.',
    ctaWhatsapp: 'Contáctanos por WhatsApp',
    faqTitle: 'Preguntas Frecuentes',
    faqMore: '¿Más preguntas? Escríbenos →',
    reviewsTitle: 'Lo Que Dicen Nuestros Estudiantes',
    reviewsDesc: 'Experiencias reales de hispanohablantes que aprendieron con nosotros',
    reviewsMore: 'Ver todas las reseñas en Google →',
    crossSellTitle: 'Descubre Nuestros Otros Servicios',
    crossSellDesc: 'Todo lo que un hispanohablante necesita en Suiza, bajo un mismo techo.',
    finalTitle: '¿Listo para Dominar el Idioma?',
    finalDesc: 'Cada semana que pasa sin aprender es una oportunidad que pierdes.',
    finalCta: 'Clase de Prueba Gratis',
  },

  // Seguros Landing Page
  segurosPage: {
    seoTitle: 'Seguros en Suiza en Español · LAMal, Hogar y 3er Pilar · Broker FINMA',
    seoDesc: 'Broker FINMA/CICERO independiente: comparamos LAMal, hogar, vida y 3er pilar de todas las aseguradoras suizas. Asesoría gratis en español, ahorro medio 30% (hasta 800 CHF/año).',
    heroTitle: 'Seguros y Pensiones para Hispanohablantes en Suiza',
    heroAccent: '— LAMal, Tercer Pilar y Ahorro en Español',
    heroDesc: 'El 70% de los hispanohablantes en Suiza paga más de lo necesario por su seguro médico. Analizamos tu póliza, encontramos el ahorro y gestionamos el cambio completo.',
    heroCta: 'Ver Todos los Servicios ↓',
    heroWhatsapp: 'Consulta Gratuita por WhatsApp',
    breadServices: 'Servicios',
    breadSeguros: 'Seguros y Pensiones',
    badge1: 'CICERO N.° 31700',
    badge2: 'FINMA N.° F014686595',
    badge3: '+20.000 personas aseguradas en 5 años',
    empathyTitle: '¿Te Suena Alguna de Estas Situaciones?',
    empathy1: 'Llevas años sin revisar tu tercer pilar y no sabes si estás perdiendo dinero',
    empathy2: 'Tu familia creció pero tu seguro sigue igual que cuando llegaste',
    empathy3: 'Recibes cartas de tu aseguradora en alemán y no entiendes qué te piden',
    empathy4: 'Pagas más de 400 CHF/mes de seguro médico y no sabes si es necesario',
    empathyBottom: 'Si te identificas con alguna, estás en el sitio correcto.',
    servicesTitle: '¿Qué Necesitas Proteger?',
    servicesDesc: 'Elige tu situación y te mostramos cómo ahorrar sin perder cobertura.',
    processTitle: 'Así de Fácil',
    step1Title: 'Cuéntanos tu situación',
    step1Desc: 'Dinos qué seguros tienes y cuánto pagas',
    step2Title: 'Comparamos por ti',
    step2Desc: 'Analizamos todas las opciones del mercado suizo',
    step3Title: 'Ahorras sin esfuerzo',
    step3Desc: 'Gestionamos el cambio completo. Tú solo firmas',
    ctaTitle: '¿Estás Pagando de Más por tu Seguro?',
    ctaDesc: 'Envíanos tu póliza actual y en 24h te decimos cuánto puedes ahorrar. Gratis y sin compromiso.',
    ctaWhatsapp: 'Consulta Gratis por WhatsApp',
    ctaSchedule: 'Agendar Llamada',
    faqTitle: 'Preguntas Frecuentes',
    faqMore: '¿Más preguntas? Escríbenos →',
    reviewsTitle: 'Lo Que Dicen Nuestros Clientes',
    reviewsDesc: 'Experiencias reales de familias que ahorraron con nosotros',
    reviewsMore: 'Ver todas las reseñas en Google →',
    crossSellTitle: 'Descubre Nuestros Otros Servicios',
    crossSellDesc: 'Todo lo que un hispanohablante necesita en Suiza, bajo un mismo techo.',
    finalTitle: 'Deja de Pagar de Más. Empieza a Ahorrar Hoy.',
    finalDesc: 'Cada mes que pasa sin revisar tu seguro es dinero que pierdes.',
    finalCta: 'Consulta Gratuita por WhatsApp',
    finalBack: 'Ver Servicios ↑',
  },

  // Home SEO
  homeSeo: {
    title: 'Punto Hispano | Deja de Sobrevivir en Suiza — Gestoría, Legal y Relocation',
    description: '¿Perdido con los trámites en Suiza? +2500 hispanohablantes ya recuperaron su tranquilidad. Impuestos, permisos, seguros, vivienda y más — todo en español.',
    skipButton: 'Ver web completa',
  },

  // Digital Solutions Advanced (Cinematic)
  digitalPage: {
    seoTitle: 'Soluciones Digitales Avanzadas - Desarrollo Web, CRM, IA y Marketing | Punto Hispano',
    seoDesc: 'Transformación digital completa para empresas en Suiza: desarrollo web profesional, CRM inteligente, chatbots con IA, automatización de procesos y marketing digital.',
    seoKeywords: 'soluciones digitales suiza, desarrollo web profesional, CRM empresarial, inteligencia artificial, chatbots, automatización procesos, marketing digital, SEO suiza',
    reviewsTitle: 'LO QUE DICEN NUESTROS',
    reviewsAccent: 'CLIENTES',
    reviewsDesc: 'Experiencias reales de empresas que confían en Punto Hispano',
  },

  // Emprende - Soluciones Digitales Catalog
  emprendeDigitalPage: {
    seoTitle: 'Soluciones Digitales para Empresas | Web, CRM, IA | Punto Hispano',
    seoDesc: 'Catálogo completo de servicios digitales: desarrollo web, CRM, chatbots IA, automatización, marketing digital.',
    backLink: 'Volver a Emprende',
    badge: 'Catálogo de Servicios',
    title: 'Soluciones Digitales',
    subtitle: 'Servicios tecnológicos completos para hacer crecer tu negocio en el mundo digital. Desde desarrollo web hasta inteligencia artificial.',
    webTitle: 'Desarrollo Web',
    webDesc: 'Páginas web modernas, rápidas y optimizadas para convertir visitantes en clientes.',
    ecommerceTitle: 'E-commerce / Tienda Online',
    ecommerceDesc: 'Tiendas online completas con gestión de productos, pagos y envíos.',
    appTitle: 'Aplicaciones Móviles',
    appDesc: 'Apps nativas o híbridas para iOS y Android con experiencia premium.',
    chatbotTitle: 'Chatbots con IA',
    chatbotDesc: 'Automatiza la atención al cliente 24/7 con inteligencia artificial.',
    automationTitle: 'Automatización de Procesos',
    automationDesc: 'Optimiza tus flujos de trabajo y ahorra tiempo en tareas repetitivas.',
    marketingTitle: 'Marketing Digital',
    marketingDesc: 'Estrategias de marketing que generan resultados medibles.',
    whatIncludes: '¿Qué incluye?',
    additionalTitle: 'Servicios Adicionales',
    additionalDesc: 'Complementa tu proyecto con estos servicios especializados.',
    customDev: 'Desarrollo a medida',
    customDevDesc: 'Software personalizado para tus necesidades',
    graphicDesign: 'Diseño gráfico',
    graphicDesignDesc: 'Logos, branding y material corporativo',
    seoAudit: 'Auditoría SEO',
    seoAuditDesc: 'Análisis completo de tu presencia online',
    emailMarketing: 'Email Marketing',
    emailMarketingDesc: 'Campañas de email automatizadas',
    socialMedia: 'Redes Sociales',
    socialMediaDesc: 'Gestión y contenido para RRSS',
    techConsulting: 'Consultoría Tech',
    techConsultingDesc: 'Asesoría en tecnología y transformación digital',
    ctaTitle: '¿Necesitas algo diferente?',
    ctaDesc: 'Si no encuentras exactamente lo que buscas, cuéntanos tu idea y crearemos una solución personalizada para ti.',
    ctaSend: 'Enviar Mi Proyecto',
    ctaConsult: 'Consulta Gratuita',
  },

  // Viviendas (Housing Rentals)
  viviendasPage: {
    seoTitle: 'Habitaciones y Pisos Amueblados en Suiza | Alquiler en Español sin Permiso | Punto Hispano',
    seoDesc: 'Alquiler de habitaciones y pisos amueblados en Suiza con todo incluido (WiFi, agua, luz, calefacción). Aceptamos sin permiso de residencia. Heiden, St. Gallen, Winterthur, Zúrich, Lucerna. Atención en español.',
    badgeLoading: 'Cargando...',
    badgeAvailable: 'alojamientos disponibles',
    badgeComingSoon: 'Próximamente nuevos alojamientos',
    heroTitle: 'Encuentra tu hogar en Suiza',
    heroDesc: 'Habitaciones y pisos amueblados para hispanohablantes. Todo incluido, contratos flexibles, soporte en español.',
    where: '¿Dónde?',
    allCities: 'Todas las ciudades',
    checkIn: 'Entrada',
    checkOut: 'Salida',
    guests: 'Huéspedes',
    guestsAny: 'Cualquiera',
    guestsPerson: 'persona',
    guestsPersons: 'personas',
    guestsPlus: '4+ personas',
    search: 'Buscar',
    insurance: 'Seguro completo',
    noDeposit: 'Sin depósito',
    freeCancellation: 'Cancelación gratuita',
    wifiIncluded: 'WiFi incluido',
    wifiDesc: 'Internet de alta velocidad',
    waterIncluded: 'Agua incluida',
    waterDesc: 'Sin gastos adicionales',
    heating: 'Calefacción',
    heatingDesc: 'Climatización completa',
    spanishSupport: 'Soporte español',
    spanishSupportDesc: 'Atención personalizada',
    filterAll: 'Todos',
    filterRoom: 'Habitación',
    filterDouble: 'Doble',
    filterStudio: 'Estudio',
    filterApartment: 'Piso completo',
    sortRecommended: 'Recomendados',
    sortPriceAsc: 'Precio: menor a mayor',
    sortPriceDesc: 'Precio: mayor a menor',
    sortNewest: 'Más recientes',
    searching: 'Buscando...',
    showing: 'Mostrando',
    accommodations: 'alojamientos',
    noAccommodations: 'Sin alojamientos por ahora',
    sortBy: 'Ordenar por:',
    whyChooseUs: '¿Por qué elegirnos?',
    bestOption: 'La mejor opción para hispanohablantes en Suiza',
    sectionTitle: 'Habitaciones y pisos amueblados',
    sectionSubtitle: 'disponibles en Suiza',
    featuredSingular: 'habitación destacada',
    featuredPlural: 'habitaciones destacadas',
    thisWeek: 'esta semana',
    accommodationSingular: 'alojamiento',
    viewGrid: 'Cuadrícula',
    viewMap: 'Mapa',
    cleaningTitle: 'Limpieza semanal',
    cleaningDesc: 'Zonas comunes incluidas',
    registrationTitle: 'Empadronamiento',
    registrationDesc: 'Registro oficial disponible',
    contractBadge: 'Contrato transparente',
    contractTitle: 'Vivir en Suiza,',
    contractTitleLight: 'sin requisitos imposibles.',
    contractDesc: 'Punto Hispano Immobilien GmbH — gestora inmobiliaria registrada en Suiza (CHE-240.749.559). Firmamos un contrato de subarriendo claro, legal y en español. Sin avales bancarios ni permiso suizo obligatorio.',
    contract01Title: 'Contrato oficial 6 meses',
    contract01Desc: 'Subarriendo legal sujeto al Código suizo de las Obligaciones (OR) con duración mínima de 6 meses. Estancias más cortas posibles bajo consulta.',
    contract02Title: 'Sin permiso obligatorio',
    contract02Desc: 'Aceptamos a personas con permiso B, C, L, G, en trámite o sin permiso. Lo importante es la seriedad y la voluntad de pago.',
    contract03Title: 'Todo incluido',
    contract03Desc: 'Wifi, agua, calefacción, electricidad, basura y limpieza de zonas comunes. Sin costes ocultos a fin de mes.',
    contract04Title: 'Depósito reembolsable',
    contract04Desc: 'Una mensualidad de fianza que se devuelve íntegra al finalizar el contrato, si todo está en orden.',
    contract05Title: 'Atención en español',
    contract05Desc: 'Todo el proceso (contrato, dudas, incidencias) lo gestionamos en español con un equipo hispanohablante.',
    contract06Title: 'Renovación automática',
    contract06Desc: 'Pasados los 6 meses el contrato se renueva cada 2 meses, salvo que usted o nosotros lo cancelemos por escrito.',
    contractFooter: 'Contrato sujeto al Código suizo de las Obligaciones (OR) y la VMWG · Jurisdicción cantón de Zúrich · Direcciones exactas tras la primera conversación.',
    whyBadge: 'Por qué nosotros',
    whyTitle: 'Una gestora',
    whyTitleAccent: 'suiza',
    whyTitleEnd: 'que habla su idioma.',
    whyDesc: 'Somos un equipo hispanohablante con gestora propia inscrita en el registro mercantil suizo (CHE-240.749.559). Combinamos experiencia local, contratos legalmente válidos y trato cercano en español, alemán e inglés.',
    whyItem1: 'Atención 100% en tu idioma',
    whyItem2: 'Contrato firmado por una GmbH suiza registrada',
    whyItem3: 'Aceptamos personas con o sin permiso de residencia',
    whyItem4: 'Wifi, agua, luz y calefacción incluidos',
    whyItem5: 'Soporte continuo durante toda su estancia',
    ctaBadge: 'Reserve su habitación',
    ctaTitle: '¿Listo para reservar su',
    ctaTitleLight: 'habitación en Suiza?',
    ctaDesc: 'Cuéntenos su situación por WhatsApp. Le confirmaremos disponibilidad real, precio cerrado y fecha de entrada — sin compromiso y sin necesidad de visita.',
    ctaWhatsapp: 'Contactar por WhatsApp',
    relatedBadge: 'Curado para usted',
    relatedTitle: 'Relacionado con esta habitación',
  },

  // Property Detail Page
  propertyDetail: {
    roomNotFound: 'Habitación no encontrada',
    roomNotFoundDesc: 'Es posible que ya esté ocupada o que el enlace no sea correcto.',
    seeAllRooms: 'Ver todas las habitaciones',
    backToList: 'Volver al listado',
    statusAvailable: 'Disponible ahora',
    statusReserved: 'Reservada',
    statusOccupied: 'Ocupada · Lista de espera',
    statusMaintenance: 'En mantenimiento',
    pricePerMonth: '/ mes',
    allIncluded: 'Todo incluido',
    priceOnRelease: 'Precio disponible al liberarse',
    priceOnReleaseDesc: 'Precio disponible cuando esta habitación se libere',
    loginToSave: 'Inicie sesión para guardar favoritos en su cuenta',
    loginToSaveDesc: 'Mientras tanto, lo guardamos en este dispositivo.',
    removedFromFavorites: 'Eliminado de favoritos',
    savedToFavorites: 'Guardado en favoritos',
    favorite: 'Favorito',
    share: 'Compartir',
    print: 'Imprimir',
    sectionRental: 'Alquiler',
    grossRent: 'Alquiler bruto',
    inclExpenses: '(incl. gastos)',
    availableOnRelease: 'Disponible al liberarse',
    deposit: 'Depósito:',
    managementFee: 'Gestión única:',
    minStay: 'Estancia mínima:',
    months: 'meses',
    availability: 'Disponibilidad:',
    immediate: 'Inmediata',
    onRequest: 'Consultar',
    sectionDetails: 'Detalles',
    typeLabel: 'Tipo:',
    roomsLabel: 'Habitaciones:',
    capacity: 'Capacidad:',
    person: 'persona',
    persons: 'personas',
    surface: 'Superficie:',
    equipment: 'Equipamiento:',
    permits: 'Permisos:',
    permitB: 'Permiso de residencia anual',
    permitC: 'Permiso de establecimiento',
    permitL: 'Permiso de corta duración',
    permitG: 'Permiso de trabajador fronterizo',
    permitF: 'Admisión provisional',
    noPermitNeeded: 'en trámite o sin permiso',
    registrationLabel: 'Empadronamiento:',
    includedLabel: 'Incluido',
    sectionDescription: 'Descripción',
    managementTitle: 'Lo que incluye nuestra gestión',
    mgmt1: 'Empadronamiento y desempadronamiento',
    mgmt2: 'Videollamada de bienvenida',
    mgmt3: 'Visita obligatoria a nuestra oficina',
    mgmt4: 'Asesoramiento incluido',
    mgmt5: 'Seguimiento hasta papeles',
    mgmt6: 'Contrato firmado conforme al Código suizo de las Obligaciones',
    mgmt7: 'Asesoría sobre la vivienda y la zona',
    mgmt8: 'Soporte continuo durante toda la estancia',
    sidebarContact: 'Contactar',
    writeWhatsApp: 'Escribir por WhatsApp',
    responseTime: 'Respondemos en menos de 2 horas en horario laboral.',
    trustRegistered: 'Empresa registrada en Suiza · CHE-240.749.559',
    trustContracts: 'Contratos legales y fianza protegida',
    trustSpanish: 'Soporte en español',
    sectionLocation: 'Ubicación',
    directions: 'Cómo llegar',
    appleMaps: 'Apple Maps',
    copy: 'Copiar',
    locationDisclaimer: 'Las indicaciones se calculan a la zona aproximada. La dirección exacta se comparte tras confirmar la reserva.',
    curatedForYou: 'Curado para usted',
    seeAll: 'Ver todas →',
    photoLabel: 'Foto',
    closeGallery: 'Cerrar ✕',
    prevPhoto: 'Foto anterior',
    nextPhoto: 'Foto siguiente',
    consultOnRelease: 'Consultar al liberarse',
    locationCopied: 'Ubicación copiada al portapapeles',
    copyFailed: 'No se pudo copiar. Inténtelo de nuevo.',
    similarRoomsIn: 'Habitaciones similares en',
  },

  // Vehículos (Vehicle Rentals)
  vehiculosPage: {
    seoTitle: 'Alquiler de Vehículos en Suiza | Comparador de Precios | Punto Hispano',
    seoDesc: 'Compara y reserva coches de alquiler en Suiza. Seguro completo, kilómetros ilimitados y atención en español.',
    badgeText: 'Comparador de Alquiler',
    heroTitle: 'Encuentra tu vehículo ideal',
    heroDesc: 'Compara precios y reserva online. Seguro incluido, kilómetros ilimitados y atención en español.',
    trustInsurance: 'Seguro completo sin franquicia',
    trustKm: 'Km ilimitados incluidos',
    trustGps: 'GPS y asistencia 24/7',
    trustSpanish: 'Atención 100% en español',
    loading: 'Cargando...',
    loadingFleet: 'Cargando flota disponible...',
    errorTitle: 'Error al cargar los vehículos',
    errorDesc: 'Por favor, inténtalo de nuevo más tarde',
    showing: 'Mostrando',
    vehiclesAvailable: 'vehículos disponibles',
    noVehiclesTitle: 'No hay vehículos para estas fechas',
    noVehiclesDesc: 'Intenta cambiar las fechas de tu búsqueda o selecciona otra ubicación de recogida.',
    changeDates: 'Cambiar fechas',
    clearFilters: 'Limpiar filtros',
    needHelp: '¿Necesitas ayuda personalizada?',
    contactWhatsapp: 'Contactar por WhatsApp',
    filters: 'Filtros',
    ctaTitle: '¿Listo para alquilar tu coche?',
    ctaDesc: 'Reserva ahora con kilómetros ilimitados, GPS incluido y seguro completo.',
    ctaWhatsapp: 'Reservar por WhatsApp',
    ctaContact: 'Formulario de Contacto',
  },

  // Emprende Index
  emprendePage: {
    seoTitle: 'Emprende con Punto Hispano | Soluciones Digitales y Desarrollo Web',
    seoDesc: 'Impulsa tu negocio digital: desarrollo web, CRM, IA, automatización y marketing. Cuéntanos tu idea y la hacemos realidad.',
    badge: 'Soluciones Digitales',
    heroTitle1: 'Impulsa Tu',
    heroTitle2: ' Negocio Digital',
    heroDesc: 'Desarrollo web, inteligencia artificial, automatización y marketing digital. Transformamos tus ideas en soluciones tecnológicas que generan resultados.',
    ctaIdea: 'Cuéntanos Tu Idea',
    ctaSolutions: 'Ver Soluciones',
    servicesTitle: 'Nuestros Servicios Digitales',
    servicesDesc: 'Soluciones tecnológicas completas para hacer crecer tu negocio en el mundo digital.',
    svc1Title: 'Desarrollo Web', svc1Desc: 'Páginas web modernas, rápidas y optimizadas para convertir visitantes en clientes.', svc1F1: 'Diseño responsive', svc1F2: 'SEO incluido', svc1F3: 'CMS integrado',
    svc2Title: 'Chatbots con IA', svc2Desc: 'Automatiza la atención al cliente 24/7 con inteligencia artificial avanzada.', svc2F1: 'Respuestas naturales', svc2F2: 'Multi-idioma', svc2F3: 'Integración CRM',
    svc3Title: 'Automatización', svc3Desc: 'Optimiza tus procesos de negocio y ahorra tiempo en tareas repetitivas.', svc3F1: 'Workflows', svc3F2: 'Integraciones', svc3F3: 'Reportes automáticos',
    svc4Title: 'Apps Móviles', svc4Desc: 'Aplicaciones nativas o híbridas para iOS y Android.', svc4F1: 'UI/UX premium', svc4F2: 'Push notifications', svc4F3: 'Offline mode',
    svc5Title: 'Marketing Digital', svc5Desc: 'Estrategias de marketing que generan resultados medibles.', svc5F1: 'SEO & SEM', svc5F2: 'Social Media', svc5F3: 'Email Marketing',
    svc6Title: 'E-commerce', svc6Desc: 'Tiendas online completas con pasarelas de pago y gestión de inventario.', svc6F1: 'Pagos seguros', svc6F2: 'Gestión stock', svc6F3: 'Envíos automatizados',
    processTitle: 'Cómo Trabajamos',
    processDesc: 'Un proceso claro y transparente desde tu idea hasta el producto final.',
    proc1: 'Cuéntanos tu idea', proc1Desc: 'Describe tu proyecto y objetivos. No importa si solo es una idea inicial.',
    proc2: 'Análisis y propuesta', proc2Desc: 'Evaluamos la viabilidad técnica y te presentamos una propuesta detallada.',
    proc3: 'Desarrollo', proc3Desc: 'Construimos tu solución con metodologías ágiles y entregas incrementales.',
    proc4: 'Lanzamiento', proc4Desc: 'Desplegamos tu proyecto y te acompañamos en el lanzamiento.',
    card1Title: 'Transmite Tu Idea', card1Desc: '¿Tienes un proyecto en mente? Cuéntanos y lo hacemos realidad.', card1Cta: 'Enviar Idea',
    card2Title: 'Gana Dinero Online', card2Desc: 'Aprende a monetizar tus habilidades y crear ingresos digitales.', card2Cta: 'Ver Guías',
    card3Title: 'Colabora con Nosotros', card3Desc: 'Únete a nuestro programa de partners y colaboradores.', card3Cta: 'Ser Partner',
    finalTitle: '¿Listo para Digitalizar tu Negocio?',
    finalDesc: 'Contáctanos hoy y descubre cómo podemos ayudarte a crecer en el mundo digital.',
    finalWhatsapp: 'Contactar por WhatsApp',
    finalSchedule: 'Agendar Consulta',
  },

  // Políticas Index
  politicasPage: {
    seoTitle: 'Políticas y Documentos Legales | Punto Hispano',
    seoDesc: 'Documentación legal, políticas de privacidad, cookies y términos de uso de Punto Hispano.',
    title: 'Políticas y Documentos Legales',
    subtitle: 'Transparencia y cumplimiento normativo en todos nuestros servicios',
    commitmentTitle: 'Compromiso de Transparencia',
    commitmentDesc: 'En Punto Hispano nos comprometemos a mantener una total transparencia sobre cómo operamos, cómo tratamos sus datos y qué derechos tiene como usuario de nuestros servicios.',
    avisoLegal: 'Aviso Legal',
    avisoLegalDesc: 'Información sobre la entidad titular de esta web, condiciones generales de uso y derechos de propiedad intelectual.',
    privacidad: 'Política de Privacidad',
    privacidadDesc: 'Información detallada sobre cómo recopilamos, utilizamos, compartimos y protegemos sus datos personales.',
    cookies: 'Política de Cookies',
    cookiesDesc: 'Información sobre qué cookies utilizamos, para qué sirven y cómo puede configurar sus preferencias.',
    gdpr: 'Política GDPR',
    gdprDesc: 'Información completa sobre protección de datos personales según el GDPR y sus derechos como usuario.',
    questionTitle: '¿Tiene alguna duda o consulta adicional?',
    questionDesc: 'Si tiene alguna pregunta sobre nuestras políticas, contacte con nuestro Delegado de Protección de Datos en',
    lastUpdate: 'Última actualización de nuestras políticas: 5 de mayo de 2025',
  },

  // FAQ Page
  faqPage: {
    seoTitle: 'Preguntas Frecuentes | Punto Hispano',
    seoDesc: 'Respuestas a las preguntas más frecuentes sobre nuestros servicios de gestoría, legal, idiomas, traducciones, diseño web, seguros y soluciones digitales en Suiza.',
    title: 'Preguntas Frecuentes',
    subtitle: 'Respuestas a las consultas más habituales sobre nuestros servicios',
    notFound: '¿No encuentra respuesta a su pregunta? No dude en contactarnos.',
    phone: 'Teléfono',
    email: 'Email',
    cat1: 'Generales',
    cat2: 'Gestoría y Administración',
    cat3: 'Asesoría Legal',
    cat4: 'Cursos de Idiomas',
    cat5: 'Traducciones Oficiales',
    cat6: 'Diseño Web y Hosting',
    cat7: 'Consultoría de Seguros',
    cat8: 'Soluciones Digitales',
    q1_1: '¿Qué servicios ofrece Punto Hispano?',
    a1_1: 'Punto Hispano ofrece una amplia gama de servicios profesionales para la comunidad hispanohablante en Suiza, incluyendo gestoría y administración, asesoría legal, cursos de idiomas, traducciones oficiales, diseño web y hosting, consultoría de seguros y soluciones digitales avanzadas.',
    q1_2: '¿En qué idiomas ofrecen sus servicios?',
    a1_2: 'Nuestros servicios están disponibles principalmente en español, pero también atendemos en alemán, inglés e italiano según las necesidades del cliente.',
    q1_3: '¿Cómo puedo solicitar una cotización para un servicio?',
    a1_3: 'Puede solicitar una cotización a través de nuestro formulario de contacto en la sección \'Contacto\', llamando al +41 77 231 72 88 o enviando un email a info@puntohispano.ch.',
    q1_4: '¿Tienen servicios personalizados para empresas?',
    a1_4: 'Sí, ofrecemos soluciones personalizadas para empresas en todas nuestras áreas de servicio, adaptándonos a las necesidades específicas de cada negocio.',
    q1_5: '¿Dónde está ubicada su oficina principal?',
    a1_5: 'Nuestra oficina principal está ubicada en Thurgauerstrasse 117, 8152 Opfikon, Zúrich, Suiza. Atendemos con cita previa.',
    q2_1: '¿Qué incluye el servicio de creación de empresas?',
    a2_1: 'Nuestro servicio de creación de empresas incluye asesoramiento sobre la forma jurídica más adecuada, preparación de documentación, registro mercantil, gestiones ante la administración, inscripción fiscal y trámites con la seguridad social.',
    q2_2: '¿Cómo funciona la planificación fiscal?',
    a2_2: 'Realizamos un análisis personalizado de su situación fiscal, identificamos oportunidades de optimización legal, y le asesoramos sobre deducciones y beneficios fiscales aplicables según la normativa suiza.',
    q2_3: '¿Pueden gestionar mi declaración de impuestos?',
    a2_3: 'Sí, ofrecemos servicios completos de gestión de declaraciones de impuestos para particulares.',
    q3_1: '¿Qué documentos necesito para la reagrupación familiar?',
    a3_1: 'Para la reagrupación familiar generalmente se necesita: permiso de residencia del solicitante, actas de matrimonio/nacimiento legalizadas, prueba de medios económicos suficientes, contrato de alquiler que demuestre espacio adecuado, y en algunos casos, certificados de idiomas.',
    q3_2: '¿Ofrecen asesoramiento en derecho laboral suizo?',
    a3_2: 'Sí, proporcionamos asesoramiento completo en derecho laboral suizo, incluyendo revisión de contratos, condiciones laborales, despidos, indemnizaciones y conflictos laborales.',
    q4_1: '¿Cuál es el precio de los cursos de alemán?',
    a4_1: 'Los precios varían según el nivel, la modalidad y la duración. Ofrecemos opciones desde CHF 40 por hora en clases grupales hasta CHF 90 por sesión en clases particulares.',
    q4_2: '¿Puedo tener una clase de prueba antes de inscribirme?',
    a4_2: 'Sí, ofrecemos una clase de prueba gratuita para que pueda conocer nuestra metodología y evaluar el nivel que mejor se ajusta.',
    q5_1: '¿Son válidas sus traducciones para trámites oficiales?',
    a5_1: 'Sí, nuestras traducciones oficiales están realizadas por traductores jurados y son válidas para presentar ante organismos oficiales tanto en Suiza como en el extranjero.',
    q5_2: '¿Cuánto tiempo se tarda en hacer una traducción jurada?',
    a5_2: 'Generalmente para documentos estándar el plazo es de 2-3 días laborables. Para documentos urgentes ofrecemos servicios express.',
    q6_1: '¿Qué incluye el paquete de web profesional?',
    a6_1: 'Incluye: diseño personalizado de 5-7 páginas, responsive design, SEO básico, integración de Analytics, formulario de contacto, hosting por un año y mantenimiento durante 3 meses.',
    q6_2: '¿Puedo actualizar mi sitio web por mi cuenta después?',
    a6_2: 'Sí, implementamos un CMS que le permite actualizar textos, imágenes y secciones de forma sencilla. También ofrecemos formación básica.',
    q7_1: '¿Cómo puedo reducir mi prima del seguro de salud?',
    a7_1: 'Existen varias estrategias: ajustar la franquicia, optar por un modelo HMO, evaluar si califica para subsidios cantonales, o combinar diferentes coberturas.',
    q7_2: '¿Qué seguros son obligatorios en Suiza?',
    a7_2: 'El seguro médico básico (KVG/LAMal) es obligatorio para todas las personas residentes. Para propietarios de vehículos, el seguro de responsabilidad civil también es obligatorio.',
    q8_1: '¿Qué es un CRM y cómo puede beneficiar a mi negocio?',
    a8_1: 'Un CRM permite gestionar las relaciones con los clientes de forma centralizada. Los beneficios incluyen mejor organización de datos, automatización de procesos de venta y análisis de comportamiento.',
    q8_2: '¿Qué soluciones de IA ofrecen para pequeñas empresas?',
    a8_2: 'Ofrecemos chatbots para atención 24/7, automatización de tareas administrativas, análisis predictivo de datos y asistentes virtuales para agendamiento.',
  },

  // Pack Relocation
  relocationPage: {
    seoTitle: 'Pack Relocation Suiza | Emigrar Sin Riesgos | Punto Hispano',
    seoDesc: 'Servicio integral de relocation a Suiza. Vivienda verificada, trámites completos, acompañamiento presencial. Desde 349 CHF.',
    seoKeywords: 'relocation suiza, emigrar suiza, mudanza suiza, pack relocation, punto hispano',
    breadHome: 'Inicio',
    breadServices: 'Servicios',
    breadRelocation: 'Pack Relocation',
    badge1: '100% Éxito',
    badge2: '+50 Familias',
    badge3: '+10 Años',
    heroTitle: 'Emigra a Suiza',
    heroAccent: 'Sin Riesgos',
    heroDesc: 'La única asesoría que te garantiza vivienda verificada, documentación completa y acompañamiento desde antes de tu llegada hasta tu integración total.',
    heroCta: 'Ver Packs',
    heroWhatsapp: 'Consulta Gratuita',
    empathyTitle: '¿Te Suena Esto?',
    empathyDesc: 'Emigrar es emocionante, pero también puede ser abrumador',
    empathy1Title: 'Llegar sin saber por dónde empezar',
    empathy1Desc: 'No hablas el idioma, no conoces el sistema y cada trámite parece un laberinto.',
    empathy2Title: 'Miedo a estafas de piso',
    empathy2Desc: 'Agencias fantasma, depósitos perdidos y contratos abusivos son más comunes de lo que crees.',
    empathy3Title: 'Papeles que no entiendes',
    empathy3Desc: 'Permiso B, seguro obligatorio, registro comunal... todo en alemán, francés o italiano.',
    empathy4Title: 'Sentirte solo al llegar',
    empathy4Desc: 'Sin red de apoyo, sin saber a quién preguntar ni dónde ir cuando algo sale mal.',
    empathyBottom: 'Si algo de esto te suena, no estás solo.',
    empathyBottomBold: 'Más de 50 familias',
    empathyBottomEnd: 'ya emigraron con nosotros sin pasar por nada de esto.',
    packsTitle: 'Paquetes de Relocalización',
    packsDesc: 'Elige el paquete perfecto para tu mudanza a Suiza',
    packMostSold: '⭐ Más Vendido',
    processTitle: 'Así de Fácil',
    step1Title: 'Cuéntanos tu situación',
    step1Desc: 'Te hacemos una evaluación gratuita para entender qué necesitas y qué pack se adapta mejor.',
    step2Title: 'Preparamos todo',
    step2Desc: 'Documentación, vivienda verificada, seguros y trámites: lo dejamos todo listo antes de tu llegada.',
    step3Title: 'Llegas y disfrutas',
    step3Desc: 'Te acompañamos presencialmente el primer día y te damos soporte extendido hasta que estés integrado.',
    faqTitle: 'Preguntas Frecuentes',
    crossSellTitle: 'Servicios Complementarios',
    finalTitle: '¿Listo para dar el paso?',
    finalDesc: 'Más de 50 familias ya emigraron con nuestra ayuda.',
    finalCta: 'Empieza tu Relocation',
  },

  // Contacto Page
  contactoPage: {
    seoTitle: 'Contacto | Gestoría y Asesoría en Suiza | Punto Hispano',
    seoDesc: 'Escríbanos por WhatsApp o email o reserve cita en Zúrich. Respuesta rápida en español.',
    heroTitle: 'Hablemos',
    heroDesc: 'Nuestro equipo de profesionales bilingües está listo para atender tus necesidades. Elige la forma de contacto que prefieras.',
    whatsappBtn: 'WhatsApp Directo',
    formBtn: 'Formulario de Contacto',
    formTitle: 'Formulario de Contacto',
    successTitle: '¡Mensaje Enviado!',
    successDesc: 'Gracias por contactarnos. Hemos recibido su mensaje y nos pondremos en contacto en las próximas 24 horas.',
    sendAnother: 'Enviar otro mensaje',
    labelName: 'Nombre Completo',
    placeholderName: 'Ingrese su nombre completo',
    labelEmail: 'Correo Electrónico',
    placeholderEmail: 'su.email@ejemplo.com',
    labelPhone: 'Teléfono (opcional)',
    placeholderPhone: '+41 XX XXX XX XX',
    labelService: 'Área de Servicio',
    selectService: 'Seleccione un área',
    optGestoria: 'Gestoría y Fiscal',
    optLegal: 'Asesoría Legal',
    optIdiomas: 'Formación en Idiomas',
    optSeguros: 'Seguros y Pensiones',
    optDigital: 'Soluciones Digitales',
    optOther: 'Otro',
    labelMessage: 'Su Mensaje',
    placeholderMessage: 'Cuéntenos en qué podemos ayudarle...',
    sending: 'Enviando mensaje...',
    sendBtn: 'Enviar Mensaje',
    toastSuccess: 'Formulario enviado',
    toastSuccessDesc: 'Hemos recibido su mensaje. Nos pondremos en contacto pronto.',
    toastError: 'Error al enviar',
    toastErrorDesc: 'Hubo un problema al enviar su mensaje. Por favor intente nuevamente.',
    infoTitle: 'Información de Contacto',
    infoDesc: 'Nuestro equipo multilingüe está preparado para atenderle en español, alemán e inglés. Contáctenos por cualquiera de estos medios.',
    officeTitle: 'Nuestra Oficina',
    phoneTitle: 'Teléfono',
    whatsappTitle: 'WhatsApp Directo',
    emailTitle: 'Correo Electrónico',
    hoursTitle: 'Horario de Atención',
    monFri: 'Lunes - Viernes',
    sat: 'Sábado',
    sun: 'Domingo',
    closed: 'Cerrado',
    needHelp: '¿Necesita ayuda inmediata?',
    needHelpDesc: 'Contáctenos directamente por WhatsApp para atención rápida',
    validName: 'El nombre debe tener al menos 2 caracteres',
    validEmail: 'Por favor ingrese un correo electrónico válido',
    validService: 'Por favor seleccione un área de servicio',
    validMessage: 'El mensaje debe tener al menos 10 caracteres',
  },

  // Contacto Form Page
  contactoFormPage: {
    seoTitle: 'Formulario de Contacto | Punto Hispano',
    seoDesc: 'Contáctenos para consultas sobre nuestros servicios. Respondemos en 24-48 horas laborables.',
    title: 'Formulario de Contacto',
    subtitle: 'Complete el formulario a continuación para enviarnos su consulta. Nuestro equipo se pondrá en contacto con usted lo antes posible.',
    successTitle: '¡Mensaje Enviado!',
    successDesc: 'Gracias por contactarnos. Hemos recibido su mensaje y nos pondremos en contacto con usted lo más pronto posible, normalmente en un plazo de 24-48 horas laborables.',
    sendAnother: 'Enviar otro mensaje',
    labelName: 'Nombre completo',
    placeholderName: 'Ingrese su nombre',
    labelEmail: 'Correo electrónico',
    labelPhone: 'Teléfono (opcional)',
    placeholderPhone: 'Su número de teléfono',
    labelService: 'Área de servicio',
    selectService: 'Seleccione un área',
    optGestoria: 'Gestoría y Administración',
    optLegal: 'Asesoría Legal',
    optIdiomas: 'Formación en Idiomas',
    optSeguros: 'Seguros y Pensiones',
    optDigital: 'Soluciones Digitales',
    optCoches: 'Alquiler de Coches',
    optViviendas: 'Alquiler de Viviendas',
    labelMessage: 'Mensaje',
    placeholderMessage: '¿En qué podemos ayudarle?',
    sending: 'Enviando...',
    sendBtn: 'Enviar Mensaje',
    privacyText: 'Al enviar este formulario, acepta nuestra',
    privacyLink: 'política de privacidad',
    privacyEnd: 'y el tratamiento de sus datos para responder a su consulta.',
    fastResponse: 'Respuesta rápida',
    fastResponseDesc: '24-48h laborables',
    noCommitment: 'Consulta sin compromiso',
    noCommitmentDesc: 'Presupuestos personalizados',
    spanishSupport: 'Atención en español',
    spanishSupportDesc: 'Equipo 100% hispanohablante',
  },

  // Oficinas Page
  oficinasPage: {
    seoTitle: 'Oficina Opfikon | Punto Hispano',
    seoDesc: 'Visita nuestra oficina en Opfikon, Zürich. Ubicación, horario, transporte y cómo encontrarnos.',
    heroTitle: 'Nuestra Oficina en Opfikon',
    heroDesc: 'Visítanos en el centro comercial TMC, a minutos del centro de Zürich. Nuestro equipo te atenderá personalmente en español.',
    howToFind: 'Cómo Encontrarnos — Paso a Paso',
    step1Title: 'Busca el edificio TMC',
    step1Desc: 'Es un centro comercial con showroom en la Thurgauerstrasse 117. Verás el letrero "TMC" en la fachada y el número 117 a la derecha.',
    step2Title: 'Entra y camina recto',
    step2Desc: 'Al entrar por la puerta principal, camina recto por el pasillo hasta que veas una cafetería.',
    step3Title: 'Sube a la 1ª planta',
    step3Desc: 'Junto a la cafetería encontrarás el ascensor. Sube a la primera planta.',
    step4Title: 'Gira a la derecha',
    step4Desc: 'Al salir del ascensor, gira a la derecha. Nuestra oficina es la 181 — verás el logo de Punto Hispano en la recepción.',
    tmcNote: 'Estamos dentro del centro comercial TMC (Trade Mart Center), un edificio de showrooms y oficinas.',
    enlargeMap: 'Ampliar Mapa',
    addressTitle: 'Dirección',
    phoneTitle: 'Teléfono',
    emailTitle: 'Correo electrónico',
    hoursTitle: 'Horario de Atención',
    appointmentsTitle: 'Citas',
    appointmentsDesc: 'Para una mejor atención, te recomendamos concertar una cita previa.',
    requestAppointment: 'Solicitar Cita',
    howToGet: 'Cómo Llegar',
    train: 'Tren',
    trainDesc: 'Estación de Opfikon, 5 minutos a pie',
    bus: 'Bus',
    busDesc: 'Líneas 759, 781 - Parada Thurgauerstrasse',
    car: 'Automóvil',
    carDesc: 'Estacionamiento disponible en el edificio',
    airport: 'Desde aeropuerto',
    airportDesc: '10 minutos en taxi o bus directo',
    parkingTitle: 'Estacionamiento',
    parkingDesc: 'El edificio TMC dispone de estacionamiento para clientes con tarifas por hora. Alternativamente, hay estacionamiento público en las cercanías.',
    additionalInfo: 'Información Adicional',
    accessibilityTitle: 'Accesibilidad',
    accessibilityDesc: 'Nuestras oficinas cuentan con acceso para personas con movilidad reducida. El edificio dispone de ascensores y rampas de acceso.',
    walkInsTitle: 'Visitas sin cita',
    walkInsDesc: 'Aunque recomendamos concertar cita previa para garantizar disponibilidad, atendemos visitas sin cita según disponibilidad del equipo.',
    nearbyTitle: 'Servicios cercanos',
    nearbyDesc: 'Dentro del propio edificio TMC encontrarás una cafetería donde puedes esperar cómodamente si llegas con antelación.',
    otherContactTitle: '¿Prefieres contactarnos de otra manera?',
    otherContactDesc: 'Si no puedes visitarnos en persona, disponemos de otras vías de contacto para atenderte.',
    contactForm: 'Formulario de Contacto',
    whatsappChat: 'WhatsApp & Chat',
    days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
    satHours: '10:00 - 14:00 (con cita)',
    closed: 'Cerrado',
  },

  // Quiénes Somos Page
  quienesSomosPage: {
    seoTitle: 'Quiénes Somos - Punto Hispano | Servicios Profesionales para Hispanohablantes en Suiza',
    seoDesc: 'Conoce a Punto Hispano: 12+ años ayudando a hispanohablantes en Suiza. Gestoría, seguros, legal, idiomas y servicios digitales.',
    badge: 'Sobre Nosotros',
    heroTitle: 'Punto Hispano:',
    heroAccent: 'Su puente entre Suiza y el mundo hispanohablante',
    heroDesc: 'Desde 2013, facilitamos la integración y el éxito de la comunidad hispanohablante en territorio suizo, combinando experiencia local con un profundo entendimiento cultural.',
    stat1: 'Clientes Satisfechos',
    stat2: 'Trámites Completados',
    stat3: 'Empresas Creadas',
    stat4: 'Años de Experiencia',
    missionBtn: 'Nuestra Misión y Visión',
    contactBtn: 'Contactar',
    teamPhoto: 'Nuestro Equipo',
    teamPhotoDesc: 'Profesionales comprometidos con tu éxito',
    historyTitle: 'Nuestra Historia',
    historySubtitle: 'Un camino de crecimiento y compromiso',
    historyDesc: 'Conozca cómo Punto Hispano evolucionó desde sus inicios hasta convertirse en el referente para la comunidad hispanohablante en Suiza.',
    timeline2013Title: 'Los inicios',
    timeline2013Desc: 'Santiago Castillo, el fundador, emprendió en Suiza con seguros y 3er pilar.',
    timeline2019Title: 'Servicios sin oficina',
    timeline2019Desc: 'Punto Hispano comenzó a ofrecer servicios profesionales a la comunidad hispanohablante.',
    timeline2023Title: 'Apertura de oficina',
    timeline2023Desc: 'Punto Hispano abrió su oficina física, marcando un hito importante.',
    timeline2025Title: 'Expansión continua',
    timeline2025Desc: 'Seguimos ampliando nuestros servicios, consolidándonos como el referente.',
    teamTitle: 'Nuestro Equipo y Oficina',
    teamSubtitle: 'Las personas detrás de Punto Hispano',
    teamDesc: 'Conozca a Santiago Castillo, nuestro fundador, y al equipo profesional.',
    founderBadge: 'Fundador',
    valuesTitle: 'Nuestros Valores',
    valuesSubtitle: 'Los principios que nos guían',
    valuesDesc: 'Cada valor representa un compromiso real con nuestros clientes y la comunidad.',
    val1Title: 'Cercanía',
    val1Desc: 'Atención personalizada y adaptada a cada cliente.',
    val2Title: 'Profesionalidad',
    val2Desc: 'Rigor, excelencia y mejora continua en todos nuestros servicios.',
    val3Title: 'Transparencia',
    val3Desc: 'Comunicación clara y honesta en todas nuestras interacciones.',
    val4Title: 'Innovación',
    val4Desc: 'Búsqueda constante de soluciones creativas y eficientes.',
    val5Title: 'Compromiso',
    val5Desc: 'Dedicación absoluta a la satisfacción y el éxito de nuestros clientes.',
    val6Title: 'Integración',
    val6Desc: 'Facilitamos el enlace entre culturas.',
    ctaTitle: '¿Listo para dar el primer paso?',
    ctaDesc: 'Contáctenos hoy para una consulta gratuita.',
    ctaBtn: 'Solicitar Consulta Gratuita',
    ctaSecondary: 'Ver Nuestros Servicios',
  },

  // Misión y Visión Page
  misionVisionPage: {
    seoTitle: 'Misión y Visión de Punto Hispano - Líder en Servicios para Hispanohablantes en Suiza',
    seoDesc: 'Descubre la misión, visión y valores de Punto Hispano: 12+ años liderando servicios profesionales para la comunidad hispanohablante en Suiza.',
    badge: 'Nuestro Propósito',
    heroTitle: 'Misión y',
    heroAccent: 'Visión',
    heroDesc: 'Conoce lo que nos impulsa a ser la referencia en servicios profesionales para la comunidad hispanohablante en Suiza',
    stat1: 'Clientes satisfechos',
    stat2: 'Años de experiencia',
    stat3: 'Compromiso con la calidad',
    stat4: 'Pilares de servicio',
    missionTitle: 'Nuestra Misión',
    missionSubtitle: 'Lo que hacemos cada día',
    missionText1: 'Proporcionar servicios profesionales integrales de máxima calidad a la comunidad hispanohablante en Suiza.',
    missionText2: 'Nos comprometemos a ser un puente confiable entre culturas.',
    missionPoints: ['Servicios profesionales integrales de máxima calidad', 'Facilitamos la integración en Suiza', 'Desarrollo profesional y bienestar personal', 'Soluciones eficientes y personalizadas', 'Puente confiable entre culturas', 'Acompañamiento cercano en tu idioma'],
    commitmentTitle: 'Compromiso Diario',
    commitmentDesc: 'Cada día trabajamos para hacer realidad nuestra misión.',
    visionTitle: 'Nuestra Visión',
    visionSubtitle: 'Hacia dónde nos dirigimos',
    visionText1: 'Ser reconocidos como la empresa líder y referente en servicios profesionales para la comunidad hispanohablante en Suiza.',
    visionText2: 'Aspiramos a transformar la experiencia de nuestros clientes en Suiza.',
    visionPoints: ['Empresa líder en servicios para hispanohablantes', 'Excelencia e innovación tecnológica', 'Enfoque humano y personalizado', 'Integración perfecta de servicios tradicionales y digitales', 'Ecosistema completo de soluciones', 'Transformación de la experiencia del cliente'],
    futureTitle: 'Futuro Brillante',
    futureDesc: 'Construimos el futuro de los servicios profesionales para la comunidad hispanohablante en Suiza.',
    valuesTitle: 'Valores que nos Definen',
    valuesSubtitle: 'Los principios fundamentales que guían cada decisión.',
    val1Title: 'Cercanía',
    val1Desc: 'Trato personal y humano',
    val2Title: 'Confianza',
    val2Desc: 'Transparencia total',
    val3Title: 'Excelencia',
    val3Desc: 'Calidad superior',
    val4Title: 'Innovación',
    val4Desc: 'Tecnología avanzada',
    ctaTitle: '¿Listo para ser parte de nuestra historia?',
    ctaDesc: 'Únete a más de 2500 clientes que ya confían en Punto Hispano.',
    ctaBtn: 'Consulta Gratuita',
    ctaSecondary: 'Ver Servicios',
  },

  // Valores Page
  valoresPage: {
    seoTitle: 'Valores Corporativos Punto Hispano - Excelencia, Confianza e Innovación en Suiza',
    seoDesc: 'Descubre los valores fundamentales de Punto Hispano: excelencia, confianza, especialización, integridad, innovación y empatía.',
    badge: 'Nuestra Filosofía',
    heroTitle: 'Nuestros',
    heroAccent: 'Valores',
    heroDesc: 'Los principios fundamentales que definen nuestra identidad y guían cada decisión.',
    stat1: 'Años de experiencia',
    stat2: 'Clientes satisfechos',
    stat3: 'Pilares de servicio',
    stat4: 'Compromiso con la calidad',
    val1Title: 'Excelencia',
    val1Desc: 'Buscamos la máxima calidad en cada servicio, superando las expectativas de nuestros clientes.',
    val2Title: 'Confianza',
    val2Desc: 'Construimos relaciones duraderas basadas en la transparencia, honestidad y cumplimiento.',
    val3Title: 'Especialización',
    val3Desc: 'Mantenemos un conocimiento profundo y actualizado de nuestras áreas de servicio.',
    val4Title: 'Integridad',
    val4Desc: 'Actuamos con rectitud y ética profesional en todas nuestras interacciones.',
    val5Title: 'Innovación',
    val5Desc: 'Incorporamos constantemente nuevas tecnologías y métodos.',
    val6Title: 'Empatía',
    val6Desc: 'Comprendemos las necesidades y circunstancias particulares de cada cliente.',
    learnMore: 'Saber más',
    commitmentTitle: 'Nuestro Compromiso Inquebrantable',
    commitmentText1: 'En Punto Hispano, estos valores no son meramente palabras en una página web, sino principios vivientes.',
    commitmentText2: 'Nos comprometemos firmemente a mantener los más altos estándares de calidad y ética profesional.',
    promiseLabel: 'Nuestra promesa:',
    promiseText: 'Cada día trabajamos para ser la referencia de confianza, excelencia y cercanía que la comunidad hispanohablante en Suiza merece y necesita.',
    meetTeam: 'Conoce nuestro equipo',
    actionTitle: 'Valores en Acción',
    actionSubtitle: 'Descubre cómo nuestros valores se traducen en beneficios tangibles.',
    qualityTitle: 'Garantía de Calidad',
    qualityDesc: 'Nuestro compromiso con la excelencia se refleja en cada servicio que prestamos.',
    qualityItems: ['Atención personalizada y dedicada', 'Seguimiento continuo de todos los procesos', 'Transparencia total en nuestras gestiones'],
    closenessTitle: 'Cercanía Humana',
    closenessDesc: 'Entendemos que detrás de cada trámite hay una persona con sueños y necesidades únicas.',
    closenessItems: ['Comunicación en tu idioma nativo', 'Comprensión de tu cultura y contexto', 'Apoyo emocional en procesos complejos'],
  },

  // Carreras Page
  carrerasPage: {
    seoTitle: 'Trabaja con Nosotros en Punto Hispano Suiza',
    seoDesc: 'Descubre oportunidades laborales en Punto Hispano: gestoría, legal, idiomas, seguros y digital.',
    badge: 'Oportunidades Profesionales',
    heroTitle: 'Trabaja con',
    heroAccent: 'Nosotros',
    heroDesc: 'Únete al equipo líder en servicios profesionales para la comunidad hispanohablante en Suiza.',
    stat1: 'Clientes satisfechos',
    stat2: 'Años de experiencia',
    stat3: 'Profesionales + colaboradores externos',
    stat4: 'Áreas de especialización',
    benefitsTitle: '¿Por qué elegir Punto Hispano?',
    benefitsSubtitle: 'Descubre las ventajas de formar parte de nuestro equipo profesional',
    ben1Title: 'Ambiente Multicultural',
    ben1Desc: 'Trabaja en un entorno colaborativo con profesionales de diversas nacionalidades',
    ben2Title: 'Crecimiento Profesional',
    ben2Desc: 'Oportunidades reales de desarrollo y promoción interna',
    ben3Title: 'Formación Continua',
    ben3Desc: 'Apoyo para certificaciones y actualización profesional constante',
    ben4Title: 'Equilibrio Vida-Trabajo',
    ben4Desc: 'Horarios flexibles y respeto por tu tiempo personal',
    ben5Title: 'Beneficios Sociales',
    ben5Desc: 'Seguros de salud, planes de pensiones y beneficios adicionales',
    ben6Title: 'Reconocimiento',
    ben6Desc: 'Sistema de incentivos y reconocimiento por desempeño excepcional',
    joinTitle: 'Únete al Equipo',
    joinSubtitle: 'Tu próxima oportunidad profesional te espera',
    joinText1: 'En Punto Hispano buscamos talento comprometido con actitud positiva y vocación de servicio.',
    joinText2: 'Forma parte de la empresa líder en servicios profesionales para hispanohablantes en Suiza.',
    processTitle: 'Proceso de Selección:',
    processSteps: ['Envío de CV y carta de presentación', 'Revisión de candidaturas y preselección', 'Entrevista inicial con RRHH', 'Entrevista técnica con el equipo', 'Propuesta de incorporación'],
    sendCV: 'Envía tu CV',
    areasTitle: 'Áreas de Especialización',
    areasSubtitle: 'Descubre las diferentes áreas donde puedes desarrollar tu carrera profesional',
    area1Title: 'Gestoría Fiscal',
    area1Desc: 'Especialistas en declaración de impuestos, contabilidad y asesoramiento fiscal.',
    area1Req: 'Experiencia en fiscalidad suiza/internacional, formación en ADE o similar.',
    area2Title: 'Asesoría Legal',
    area2Desc: 'Profesionales del derecho especializados en temas migratorios, laborales, civiles y mercantiles.',
    area2Req: 'Licenciatura/Grado en Derecho, experiencia en asesoría legal internacional.',
    area3Title: 'Formación en Idiomas',
    area3Desc: 'Profesores nativos para impartir clases personalizadas y grupales.',
    area3Req: 'Titulación oficial en enseñanza de idiomas, certificaciones (DELE, Goethe, Cambridge).',
    area4Title: 'Consultoría de Seguros',
    area4Desc: 'Asesores especializados en seguros de salud, vida y planes de jubilación.',
    area4Req: 'Certificación como asesor de seguros, experiencia en el sector suizo.',
    area5Title: 'Desarrollo Digital',
    area5Desc: 'Diseñadores y desarrolladores web, especialistas en UX/UI y marketing digital.',
    area5Req: 'Formación técnica, portfolio de proyectos, conocimientos actualizados.',
    area6Title: 'Ventas y Marketing',
    area6Desc: 'Profesionales enfocados en la captación de clientes y estrategias de posicionamiento.',
    area6Req: 'Experiencia comercial B2B, habilidades comunicativas excepcionales.',
    reqLabel: 'Requisitos:',
  },

  // Error / Not Found
  notFoundPage: {
    title: 'Página no encontrada',
    desc: 'Lo sentimos, la página que buscas no existe o fue movida.',
    goHome: 'Volver al inicio',
  },

  // Recursos Index
  recursosPage: {
    seoTitle: 'Recursos Gratuitos | Guías, Herramientas y Webinars | Punto Hispano',
    seoDesc: 'Accede a guías, calculadoras, webinars y recursos gratuitos para hispanohablantes en Suiza.',
    heroTitle: 'Centro de Recursos',
    heroSubtitle: 'Herramientas, guías y materiales gratuitos para tu éxito en Suiza',
    searchPlaceholder: 'Buscar recursos...',
    filterAll: 'Todos',
    filterGuides: 'Guías',
    filterCalculators: 'Calculadoras',
    filterWebinars: 'Webinars',
    filterVideos: 'Videos',
    filterTemplates: 'Plantillas',
    categoryAll: 'Todas las categorías',
    categoryLegal: 'Legal',
    categoryFiscal: 'Fiscal',
    categorySeguros: 'Seguros',
    categoryIdiomas: 'Idiomas',
    categoryDigital: 'Digital',
    sortPopular: 'Más populares',
    sortRecent: 'Más recientes',
    sortRating: 'Mejor valorados',
    downloads: 'descargas',
    pages: 'páginas',
    downloadBtn: 'Descargar',
    previewBtn: 'Vista previa',
    featured: 'Destacado',
    new: 'Nuevo',
    noResults: 'No se encontraron recursos con los filtros seleccionados.',
    clearFilters: 'Limpiar filtros',
    newsletterTitle: '¿Quieres recibir nuevos recursos?',
    newsletterDesc: 'Suscríbete y recibe guías y herramientas directamente en tu email.',
    newsletterBtn: 'Suscribirse',
    emailPlaceholder: 'tu@email.com',
  },

  // Guías Prácticas
  guiasPracticasPage: {
    seoTitle: 'Guías Prácticas | Recursos para Hispanohablantes | Punto Hispano',
    seoDesc: 'Guías detalladas sobre trámites y procedimientos en Suiza.',
    title: 'Guías Prácticas',
    subtitle: 'Información útil para sus trámites y gestiones',
    readTime: 'Lectura',
    readGuide: 'Leer guía',
    faqTitle: 'Preguntas Frecuentes sobre nuestras Guías',
  },

  // Whitepapers
  whitepapersPage: {
    seoTitle: 'Whitepapers | Recursos Profesionales | Punto Hispano',
    seoDesc: 'Descargue nuestros whitepapers especializados sobre fiscalidad, legalidad y transformación digital.',
    title: 'Whitepapers',
    subtitle: 'Documentos técnicos y guías profesionales',
    pages: 'páginas',
    published: 'Publicado',
    downloadPdf: 'Descargar PDF',
    faqTitle: 'Preguntas Frecuentes sobre nuestros Whitepapers',
  },

  // Videos y Webinars
  videosWebinarsPage: {
    seoTitle: 'Videos y Webinars | Recursos Audiovisuales | Punto Hispano',
    seoDesc: 'Accede a nuestros webinars y contenido audiovisual sobre trámites, impuestos y vida en Suiza.',
    title: 'Videos y Webinars',
    subtitle: 'Contenido audiovisual educativo y profesional',
    upcoming: 'Próximamente',
    past: 'Anteriores',
    register: 'Registrarse',
    watchNow: 'Ver ahora',
    duration: 'Duración',
    faqTitle: 'Preguntas Frecuentes sobre nuestros Webinars',
  },

  // Colabora
  colaboraPage: {
    seoTitle: 'Programa de Partners y Colaboradores | Punto Hispano',
    seoDesc: 'Únete a nuestro programa de partners: afiliados, partners tecnológicos y agencias.',
    heroTitle: 'Programa de Partners y Colaboradores',
    heroDesc: 'Únete a nuestro ecosistema y crece junto a nosotros.',
    backToEmprende: 'Volver a Emprende',
    whyPartner: '¿Por qué ser Partner?',
    whyPartnerDesc: 'Beneficios exclusivos de unirte a nuestro ecosistema de colaboración.',
    ben1Title: 'Comisiones Atractivas',
    ben1Desc: 'Gana comisiones competitivas por cada referido o proyecto conjunto.',
    ben2Title: 'Soporte Dedicado',
    ben2Desc: 'Equipo de soporte exclusivo para partners con prioridad.',
    ben3Title: 'Formación Continua',
    ben3Desc: 'Acceso a recursos y formaciones exclusivas para partners.',
    ben4Title: 'Crecimiento Conjunto',
    ben4Desc: 'Crece tu negocio junto al nuestro con sinergias reales.',
    ctaTitle: '¿Listo para ser nuestro Partner?',
    ctaBtn: 'Solicitar Partnership',
    ctaWhatsapp: 'Consultar por WhatsApp',
  },

  // Gana Dinero
  ganaDineroPage: {
    seoTitle: 'Gana Dinero Online | Estrategias Digitales | Punto Hispano',
    seoDesc: 'Aprende a monetizar tus habilidades y crear ingresos digitales desde Suiza.',
    heroTitle: 'Gana Dinero Online',
    heroDesc: 'Estrategias probadas para generar ingresos en el mundo digital.',
    backToEmprende: 'Volver a Emprende',
    strategiesTitle: 'Estrategias para Generar Ingresos',
    strategiesDesc: 'Descubre las mejores formas de ganar dinero online.',
    tipsLabel: 'Consejos clave:',
    ctaTitle: '¿Necesitas ayuda para empezar?',
    ctaDesc: 'Te asesoramos para lanzar tu negocio digital.',
    ctaBtn: 'Consulta Gratuita',
    ctaWhatsapp: 'WhatsApp',
  },

  // Transmite Ideas
  transmiteIdeasPage: {
    seoTitle: 'Transmite Tu Idea de Proyecto | Punto Hispano',
    seoDesc: 'Cuéntanos tu idea de proyecto digital y te ayudamos a hacerla realidad.',
    heroTitle: 'Cuéntanos Tu Idea',
    heroDesc: 'Describe tu proyecto y nuestro equipo te asesorará sobre cómo hacerlo realidad.',
    backToEmprende: 'Volver a Emprende',
    formTitle: 'Describe tu proyecto',
    labelName: 'Nombre completo',
    placeholderName: 'Tu nombre',
    labelEmail: 'Correo electrónico',
    labelPhone: 'Teléfono (opcional)',
    placeholderPhone: '+41 XX XXX XX XX',
    labelProjectType: 'Tipo de proyecto',
    labelDescription: 'Describe tu idea',
    placeholderDescription: 'Cuéntanos los detalles de tu proyecto...',
    labelBudget: 'Presupuesto estimado',
    labelUrgency: 'Urgencia',
    labelFeatures: 'Funcionalidades necesarias',
    submitBtn: 'Enviar Idea',
    sending: 'Enviando...',
    successTitle: '¡Idea Recibida!',
    successDesc: 'Hemos recibido tu propuesta. Te contactaremos para evaluar tu proyecto.',
    sendAnother: 'Enviar otra idea',
    guaranteeTitle: 'Nuestro compromiso',
    guarantee1: 'Respuesta en 24-48h',
    guarantee2: 'Evaluación gratuita',
    guarantee3: 'Sin compromiso',
    guarantee4: 'Presupuesto detallado',
  },

  // Auth
  authPage: {
    loginTitle: 'Iniciar Sesión',
    loginDesc: 'Accede a tu cuenta de Punto Hispano.',
    signupTitle: 'Crear Cuenta',
    signupDesc: 'Regístrate para acceder a todos nuestros servicios.',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    name: 'Nombre completo',
    loginBtn: 'Iniciar Sesión',
    signupBtn: 'Crear Cuenta',
    forgotPassword: '¿Olvidaste tu contraseña?',
    noAccount: '¿No tienes cuenta?',
    hasAccount: '¿Ya tienes cuenta?',
    signupLink: 'Regístrate',
    loginLink: 'Inicia sesión',
    orContinueWith: 'O continúa con',
    google: 'Google',
    resetTitle: 'Restablecer Contraseña',
    resetDesc: 'Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.',
    resetBtn: 'Enviar enlace',
    resetSuccess: 'Hemos enviado un enlace a tu correo.',
    backToLogin: 'Volver al inicio de sesión',
  },

  // Política subpages - Full content
  avisoLegalPage: {
    seoTitle: 'Aviso Legal | Información Legal | Punto Hispano',
    seoDesc: 'Información legal completa sobre Punto Hispano y sus servicios.',
    title: 'Aviso Legal',
    subtitle: 'Información legal completa sobre Punto Hispano y nuestros servicios',
    whatIs: '¿Qué es este aviso legal?',
    whatIsP1: 'Este aviso legal regula el uso del sitio web www.puntohispano.ch, del que es titular Punto Hispano GmbH, empresa registrada en Suiza.',
    whatIsP2: 'Al navegar por nuestro sitio web, usted acepta todas las condiciones aquí establecidas. Le recomendamos leer detenidamente esta información.',
    whoWeAre: '¿Quiénes somos?',
    idData: 'Datos de identificación',
    company: 'Empresa',
    companySubtitle: 'Gestoría y Asesoría en Suiza',
    officialAddress: 'Dirección oficial',
    contactTitle: '¿Cómo contactarnos?',
    digitalComm: 'Comunicación digital',
    directComm: 'Comunicación directa',
    mainEmail: 'Email principal:',
    website: 'Sitio web:',
    phone: 'Teléfono:',
    officeHours: 'Horario de atención:',
    weekdayHours: 'Lunes a viernes: 9:00 - 18:00',
    saturdayHours: 'Sábados: 10:00 - 14:00',
    termsTitle: 'Condiciones de uso del sitio web',
    term1Title: '1. Aceptación de condiciones',
    term1Desc: 'Al acceder y utilizar este sitio web, usted acepta automáticamente estar sujeto a estas condiciones de uso. Si no está de acuerdo con alguna de estas condiciones, le recomendamos que no utilice nuestro sitio.',
    term2Title: '2. Uso permitido',
    term2Desc: 'Este sitio web está destinado exclusivamente para:',
    term2Items: ['Obtener información sobre nuestros servicios', 'Solicitar consultas y presupuestos', 'Contactar con nuestro equipo profesional', 'Acceder a recursos y documentación'],
    term3Title: '3. Uso prohibido',
    term3Warning: 'Está estrictamente prohibido:',
    term3Items: ['Utilizar el sitio para actividades ilegales', 'Intentar acceder a áreas restringidas', 'Copiar o reproducir contenidos sin autorización', 'Enviar información falsa o engañosa', 'Interferir con el funcionamiento del sitio'],
    ipTitle: 'Propiedad intelectual e industrial',
    ipProtected: '¿Qué está protegido?',
    ipDesc: 'Todos los elementos de este sitio web están protegidos por las leyes de propiedad intelectual e industrial de Suiza y las normativas internacionales aplicables.',
    ipVisual: 'Elementos visuales',
    ipVisualItems: ['Diseño y maquetación', 'Logotipos y marcas', 'Imágenes y fotografías', 'Iconografía y gráficos'],
    ipTechnical: 'Elementos técnicos',
    ipTechnicalItems: ['Código de programación', 'Base de datos', 'Arquitectura web', 'Funcionalidades'],
    ipWarning: 'Queda expresamente prohibida la reproducción, distribución, comunicación pública, transformación o cualquier otra forma de explotación, total o parcial, de los contenidos de este sitio sin autorización expresa y por escrito de Punto Hispano.',
    responsibilityTitle: 'Responsabilidades y limitaciones',
    ourCommitment: 'Nuestro compromiso',
    ourCommitmentDesc: 'Punto Hispano se compromete a mantener este sitio web operativo y actualizado. Sin embargo, no podemos garantizar:',
    ourCommitmentItems: ['Disponibilidad continua 24/7 del sitio web', 'Ausencia total de errores técnicos', 'Compatibilidad con todos los navegadores', 'Protección absoluta contra ataques informáticos'],
    userResponsibility: 'Responsabilidad del usuario',
    userResponsibilityDesc: 'Como usuario del sitio web, usted es responsable de:',
    userResponsibilityItems: ['Proporcionar información veraz y actualizada', 'Mantener la confidencialidad de sus credenciales', 'Utilizar el sitio de forma responsable y legal', 'Respetar los derechos de propiedad intelectual'],
    lawTitle: 'Legislación aplicable y jurisdicción',
    applicableLaw: 'Ley aplicable',
    applicableLawDesc: 'Este aviso legal se rige por la legislación suiza, específicamente por las leyes del Cantón de Zürich y la legislación federal de Suiza.',
    jurisdiction: 'Jurisdicción competente',
    jurisdictionDesc: 'Para cualquier controversia que pueda surgir en relación con el uso de este sitio web, las partes se someten expresamente a la jurisdicción de los tribunales de Zürich, Suiza.',
    faqTitle: 'Preguntas frecuentes legales',
    faqMoreInfo: '¿Necesita más información legal específica? Contacte con nuestros expertos para una consulta personalizada',
    relatedPolicies: 'Políticas relacionadas',
    dataProtection: 'Protección de Datos',
    dataProtectionDesc: 'Conoce cómo protegemos tu información personal',
    cookiePolicyLink: 'Política de Cookies',
    cookiePolicyDesc: 'Información sobre el uso de cookies',
    privacyPolicyLink: 'Política de Privacidad',
    privacyPolicyDesc: 'Términos generales de privacidad',
    legalQuestions: '¿Dudas legales?',
    legalQuestionsDesc: 'Si tiene preguntas sobre este aviso legal o necesita aclaraciones sobre nuestras condiciones de uso, no dude en contactarnos.',
    lastUpdated: 'Última actualización:',
    lastUpdatedDate: '24 de junio de 2025',
  },
  politicaPrivacidadPage: {
    seoTitle: 'Política de Privacidad | Protección de Datos Personales | Punto Hispano',
    seoDesc: 'Política completa de privacidad de Punto Hispano. Conoce cómo recopilamos, utilizamos y protegemos tu información personal según las mejores prácticas de protección de datos.',
    titlePart1: 'Política de',
    titlePart2: 'Privacidad',
    subtitle: 'Tu privacidad es fundamental. Conoce cómo protegemos tu información personal con los más altos estándares de seguridad.',
    gdprBadge: 'GDPR Compliant',
    encryptionBadge: 'Cifrado AES-256',
    isoBadge: 'ISO 27001',
    introTitle: '¿Por qué es importante tu privacidad?',
    introP1Pre: 'En',
    introP1Brand: 'Punto Hispano',
    introP1Post: ', valoramos y respetamos tu privacidad como un derecho fundamental. Esta Política de Privacidad explica de manera transparente cómo recopilamos, utilizamos, compartimos y protegemos la información personal que nos proporcionas cuando visitas nuestro sitio web, utilizas nuestros servicios o interactúas con nosotros de cualquier manera.',
    introHighlight: 'Al utilizar nuestros servicios, aceptas las prácticas descritas en esta Política de Privacidad.',
    introBadge1: 'Transparencia Total',
    introBadge2: 'Máxima Seguridad',
    introBadge3: 'Control Total',
    whatTitle: '¿Qué información recopilamos?',
    whatIntro: 'Recopilamos diferentes tipos de información personal para poder ofrecerte nuestros servicios profesionales de la mejor manera.',
    section1Title: '1. Información que tú nos proporcionas',
    idCardTitle: 'Datos de identificación',
    idCard1: 'Nombre y apellidos completos',
    idCard2: 'Documento de identidad (DNI, NIE, pasaporte)',
    idCard3: 'Fecha de nacimiento y nacionalidad',
    contactCardTitle: 'Información de contacto',
    contactCard1: 'Dirección de correo electrónico',
    contactCard2: 'Número de teléfono móvil y fijo',
    contactCard3: 'Dirección postal completa',
    profCardTitle: 'Datos profesionales',
    profCard1: 'Empresa donde trabajas y cargo',
    profCard2: 'Sector de actividad profesional',
    profCard3: 'Información laboral relevante',
    finCardTitle: 'Información financiera',
    finCard1: 'Datos bancarios (para procesamiento de pagos)',
    finCard2: 'Información fiscal necesaria',
    finCard3: 'Documentación financiera para servicios específicos',
    section2Title: '2. Información que recopilamos automáticamente',
    autoIntroLabel: '¿Qué recopilamos?',
    autoIntroDesc: 'Cuando visitas nuestro sitio web, recopilamos automáticamente cierta información técnica.',
    autoUseLabel: 'Datos de uso:',
    autoUseDesc: 'páginas visitadas, tiempo de permanencia, enlaces utilizados',
    autoDeviceLabel: 'Información del dispositivo:',
    autoDeviceDesc: 'tipo de dispositivo, sistema operativo, navegador',
    autoLocLabel: 'Información de ubicación:',
    autoLocDesc: 'país y región (basada en tu dirección IP)',
    autoCookiesLabel: 'Cookies:',
    autoCookiesDesc: 'para más información, consulta nuestra Política de Cookies',
    useTitle: '¿Cómo utilizamos tu información?',
    useIntro: 'Utilizamos tu información personal exclusivamente para los siguientes fines legítimos:',
    useServicesTitle: 'Servicios principales',
    useService1: 'Proporcionar y mantener nuestros servicios',
    useService2: 'Procesar transacciones y pagos',
    useService3: 'Gestionar tu cuenta y perfil',
    useService4: 'Cumplir obligaciones contractuales',
    useCommTitle: 'Comunicación',
    useComm1: 'Responder a consultas y solicitudes',
    useComm2: 'Enviar actualizaciones de servicios',
    useComm3: 'Proporcionar soporte técnico',
    useComm4: 'Comunicar información importante',
    useImproveTitle: 'Mejora y análisis',
    useImprove1: 'Personalizar tu experiencia',
    useImprove2: 'Analizar tendencias y uso',
    useImprove3: 'Mejorar nuestros servicios',
    useImprove4: 'Desarrollar nuevas funcionalidades',
    useSecTitle: 'Seguridad y legal',
    useSec1: 'Detectar actividades fraudulentas',
    useSec2: 'Cumplir obligaciones legales',
    useSec3: 'Proteger derechos y seguridad',
    useSec4: 'Resolver disputas legales',
    legalTitle: 'Base legal para el tratamiento',
    legalIntro: 'Tratamos tu información personal basándonos en las siguientes bases legales reconocidas:',
    legal1Title: 'Ejecución de un contrato',
    legal1Desc: 'Cuando el tratamiento es necesario para cumplir con nuestras obligaciones contractuales contigo.',
    legal2Title: 'Consentimiento',
    legal2Desc: 'Cuando has dado tu consentimiento explícito para el tratamiento con un fin específico.',
    legal3Title: 'Intereses legítimos',
    legal3Desc: 'Cuando el tratamiento es necesario para nuestros intereses legítimos, siempre que no prevalezcan tus intereses o derechos fundamentales.',
    legal4Title: 'Obligación legal',
    legal4Desc: 'Cuando el tratamiento es necesario para cumplir con una obligación legal aplicable.',
    shareTitle: '¿Con quién compartimos tu información?',
    shareImportant: 'IMPORTANTE: No vendemos tu información personal a terceros',
    shareIntro: 'Podemos compartir tu información personal únicamente con las siguientes categorías de destinatarios:',
    share1Title: 'Proveedores de servicios',
    share1Desc: 'Empresas que prestan servicios en nuestro nombre (procesamiento de pagos, análisis de datos, alojamiento web, soporte al cliente) bajo estrictos acuerdos de confidencialidad.',
    share2Title: 'Socios comerciales',
    share2Desc: 'Terceros con los que colaboramos para ofrecer servicios específicos o promociones conjuntas, siempre con tu consentimiento previo.',
    share3Title: 'Autoridades competentes',
    share3Desc: 'Cuando sea necesario para cumplir con una obligación legal, resolución judicial o requerimiento administrativo válido.',
    share4Title: 'Transacciones corporativas',
    share4Desc: 'En el contexto de una transacción corporativa (como una fusión, adquisición o venta de activos), siempre protegiendo tus derechos.',
    intlTitle: 'Transferencias internacionales de datos',
    intlIntro: 'Tus datos personales pueden ser transferidos y tratados en países distintos a aquel en el que resides. Estos países pueden tener leyes de protección de datos diferentes a las de tu país.',
    intlGuaranteeLabel: 'Garantías de protección:',
    intlGuaranteeDesc: 'Cuando transferimos datos fuera del Espacio Económico Europeo o Suiza, nos aseguramos de que existan garantías adecuadas para proteger tus datos personales, como cláusulas contractuales tipo aprobadas por la Comisión Europea.',
    secTitle: '¿Cómo protegemos tu información?',
    secIntro: 'Implementamos medidas de seguridad técnicas, administrativas y físicas diseñadas para proteger la información personal que recopilamos.',
    secTechTitle: 'Medidas técnicas',
    secTech1: 'Cifrado AES-256 para almacenamiento',
    secTech2: 'Comunicaciones SSL/TLS seguras',
    secTech3: 'Sistemas de detección de intrusos',
    secTech4: 'Copias de seguridad encriptadas',
    secAdminTitle: 'Medidas administrativas',
    secAdmin1: 'Acceso restringido a personal autorizado',
    secAdmin2: 'Formación regular en protección de datos',
    secAdmin3: 'Políticas internas de seguridad',
    secAdmin4: 'Auditorías de seguridad periódicas',
    secLimitsLabel: 'Limitaciones:',
    secLimitsDesc: 'Aunque implementamos las mejores medidas de seguridad disponibles, ningún sistema es completamente impenetrable. No podemos garantizar la seguridad absoluta de tu información personal.',
    retentionTitle: '¿Cuánto tiempo conservamos tus datos?',
    retentionIntro: 'Conservamos tu información personal durante el tiempo necesario para cumplir con los fines descritos en esta Política de Privacidad, a menos que la ley exija un período de conservación más largo.',
    ret1Title: 'Documentos contractuales',
    ret1Desc: 'Durante la vigencia del contrato + 6 años',
    ret2Title: 'Documentos fiscales',
    ret2Desc: '10 años (requisito legal suizo)',
    ret3Title: 'Comunicaciones',
    ret3Desc: '3 años desde última interacción',
    ret4Title: 'Datos de navegación',
    ret4Desc: 'Máximo 2 años',
    rightsTitle: '¿Cuáles son tus derechos?',
    rightsIntro: 'Dependiendo de tu lugar de residencia, tienes ciertos derechos importantes con respecto a tu información personal:',
    rightAccessTitle: 'Derecho de acceso',
    rightAccessDesc: 'Puedes solicitar información sobre qué datos personales tenemos sobre ti.',
    rightRectifyTitle: 'Derecho de rectificación',
    rightRectifyDesc: 'Puedes solicitar que corrijamos datos inexactos o incompletos.',
    rightDeleteTitle: 'Derecho de supresión',
    rightDeleteDesc: 'Puedes solicitar que eliminemos tu información personal.',
    rightPortTitle: 'Derecho de portabilidad',
    rightPortDesc: 'Puedes recibir tus datos en formato estructurado y transferirlos.',
    rightOpposeTitle: 'Derecho de oposición',
    rightOpposeDesc: 'Puedes oponerte al tratamiento de tus datos en ciertas circunstancias.',
    rightWithdrawTitle: 'Retirada de consentimiento',
    rightWithdrawDesc: 'Puedes retirar tu consentimiento en cualquier momento.',
    rightsHowLabel: '¿Cómo ejercer tus derechos?',
    rightsHowDesc: 'Para ejercer estos derechos, ponte en contacto con nosotros utilizando la información proporcionada en la sección "Contacto" de esta política.',
    faqTitle: 'Preguntas frecuentes sobre privacidad',
    faqSubtitle: 'Respuestas claras a tus dudas más comunes.',
    faq1Q: '¿Qué información personal recopila Punto Hispano?',
    faq1A: 'Recopilamos información de identificación, contacto, datos profesionales y financieros necesarios para prestar nuestros servicios. Solo recopilamos los datos estrictamente necesarios y con tu consentimiento.',
    faq2Q: '¿Cómo protege Punto Hispano mi información personal?',
    faq2A: 'Implementamos medidas de seguridad técnicas y administrativas avanzadas, incluyendo cifrado AES-256, comunicaciones SSL/TLS y acceso restringido solo a personal autorizado.',
    faq3Q: '¿Puedo solicitar la eliminación de mis datos personales?',
    faq3A: 'Sí, tienes derecho a solicitar la eliminación de tus datos cuando ya no sean necesarios para los fines para los que fueron recopilados, respetando siempre las obligaciones legales aplicables.',
    faq4Q: '¿Comparte Punto Hispano mi información con terceros?',
    faq4A: 'No vendemos tu información personal. Solo la compartimos con proveedores de servicios de confianza, cuando es necesario para cumplir obligaciones legales o con tu consentimiento explícito.',
    changesTitle: 'Cambios en esta Política de Privacidad',
    changesP1: 'Podemos actualizar esta Política de Privacidad periódicamente para reflejar cambios en nuestras prácticas o por otros motivos operativos, legales o regulatorios.',
    changesNotifyLabel: 'Te notificaremos:',
    changesNotifyDesc: 'Cualquier cambio material será comunicado publicando la nueva Política de Privacidad en nuestro sitio web y actualizando la fecha de "última actualización".',
    contactTitle: '¿Tienes preguntas sobre privacidad?',
    contactIntro: 'Si tienes preguntas o inquietudes sobre esta Política de Privacidad o sobre el tratamiento de tus datos personales, ponte en contacto con nosotros:',
    contactCompanyLabel: 'Empresa:',
    contactCompanyValue: 'Punto Hispano',
    contactAddressLabel: 'Dirección:',
    contactEmailLabel: 'Email:',
    contactPhoneLabel: 'Teléfono:',
    lastUpdated: 'Última actualización:',
    lastUpdatedDate: '24 de junio de 2025',
    lastUpdateNote: 'Esta política puede ser modificada para reflejar cambios en nuestras prácticas o normativas aplicables',
  },
  politicaCookiesPage: {
    seoTitle: 'Política de Cookies | Punto Hispano',
    seoDesc: 'Información sobre las cookies que utilizamos y cómo gestionar tus preferencias.',
    title: 'Política de Cookies',
    subtitle: 'Transparencia total sobre cómo utilizamos las cookies en nuestro sitio web',
    whatAreCookies: '¿Qué son las cookies y por qué las usamos?',
    whatAreCookiesP1: 'Las cookies son pequeños archivos de texto que se guardan en tu dispositivo cuando visitas nuestro sitio web. Son completamente seguras y nos ayudan a ofrecerte una mejor experiencia de navegación.',
    whatAreCookiesP2: 'En Punto Hispano utilizamos cookies de forma responsable y transparente, siempre respetando tu privacidad y cumpliendo con la normativa europea de protección de datos.',
    cookieTypes: '¿Qué tipos de cookies utilizamos?',
    essentialTitle: 'Cookies esenciales o necesarias',
    essentialWhat: '¿Qué hacen?',
    essentialWhatDesc: 'Son imprescindibles para que nuestro sitio web funcione correctamente.',
    essentialWhy: '¿Por qué las necesitamos?',
    essentialWhyDesc: 'Te permiten navegar por el sitio, acceder a áreas seguras y utilizar funcionalidades básicas como el formulario de contacto.',
    essentialNote: 'Estas cookies no requieren tu consentimiento porque son técnicamente necesarias.',
    preferencesTitle: 'Cookies de preferencias',
    preferencesWhatDesc: 'Recuerdan tus preferencias para personalizar tu experiencia.',
    preferencesExamples: 'Idioma seleccionado, configuración de accesibilidad, preferencias de navegación.',
    preferencesNote: 'Mejoran tu experiencia pero no son imprescindibles para el funcionamiento básico.',
    analyticsTitle: 'Cookies estadísticas o analíticas',
    analyticsWhatDesc: 'Nos ayudan a entender cómo utilizas nuestro sitio web de forma anónima.',
    analyticsWhyDesc: 'Mejoramos constantemente nuestros servicios basándonos en datos reales de uso.',
    analyticsNote: 'Los datos se procesan de forma anónima y agregada, nunca identificamos usuarios individuales.',
    marketingTitle: 'Cookies de marketing',
    marketingWhatDesc: 'Nos permiten mostrarte contenido y ofertas más relevantes.',
    marketingHowDesc: 'Rastrean tu comportamiento de navegación para personalizar la experiencia.',
    marketingNote: 'Siempre puedes desactivar estas cookies sin afectar el funcionamiento básico del sitio.',
    specificCookies: 'Cookies específicas que utilizamos',
    tableName: 'Nombre',
    tableProvider: 'Proveedor',
    tablePurpose: 'Propósito',
    tableDuration: 'Duración',
    tableType: 'Tipo',
    controlTitle: '¿Cómo controlar las cookies?',
    controlDesc: 'Tienes el control total sobre las cookies. Puedes aceptarlas, rechazarlas o configurarlas según tus preferencias.',
    onOurSite: 'En nuestro sitio web',
    onOurSiteDesc: 'Cuando visitas por primera vez, aparece un banner donde puedes:',
    onOurSiteItems: ['Aceptar todas las cookies', 'Rechazar las no esenciales', 'Configurar tus preferencias detalladamente'],
    inBrowser: 'En tu navegador',
    inBrowserDesc: 'También puedes gestionar las cookies directamente desde tu navegador:',
    inBrowserItems: ['Bloquear todas las cookies', 'Eliminar cookies existentes', 'Configurar excepciones por sitio web'],
    browserSettings: 'Configuración por navegador',
    thirdPartyCookies: 'Cookies de terceros',
    thirdPartyWarning: 'Algunos servicios externos que utilizamos (como Google Analytics) pueden instalar sus propias cookies.',
    thirdPartyDesc: 'No tenemos control directo sobre estas cookies de terceros, pero nos aseguramos de que:',
    thirdPartyItems: ['Solo trabajamos con proveedores que respetan la privacidad', 'Los datos se procesan de forma anónima', 'Cumplan con la normativa europea de protección de datos', 'Puedas desactivarlas si lo deseas'],
    changesTitle: 'Cambios en nuestra Política de Cookies',
    changesDesc: 'Podemos actualizar esta política ocasionalmente para reflejar cambios en nuestros servicios o en la normativa aplicable.',
    changesNotice: 'Cualquier cambio importante será comunicado claramente en nuestro sitio web y, si es necesario, solicitaremos tu consentimiento renovado.',
    questionsTitle: '¿Tienes dudas sobre las cookies?',
    questionsDesc: 'Si tienes preguntas sobre cómo utilizamos las cookies o quieres ejercer tus derechos, no dudes en contactarnos:',
    lastUpdated: 'Última actualización:',
    lastUpdatedDate: '24 de junio de 2025',
  },
  politicaGdprPage: {
    seoTitle: 'Política GDPR | Protección de Datos Personales | Punto Hispano',
    seoDesc: 'Política de protección de datos personales según el GDPR. Conoce tus derechos y cómo tratamos tu información en Punto Hispano.',
    title: 'Protección de Datos Personales',
    subtitle: 'Tu privacidad es nuestra prioridad — Conoce tus derechos según el GDPR',
    whyImportant: '¿Por qué es importante tu privacidad?',
    whyImportantP1: 'En Punto Hispano tratamos tu información personal con el máximo respeto y transparencia. Cumplimos estrictamente con el Reglamento General de Protección de Datos (GDPR) y la Ley Federal de Protección de Datos de Suiza.',
    whyImportantP2: 'Esta política te explica de forma sencilla qué datos recopilamos, cómo los usamos y cuáles son tus derechos como usuario de nuestros servicios.',
    whoResponsible: '¿Quién es responsable de tus datos?',
    whoResponsibleDesc: 'Punto Hispano Holding es la empresa responsable del tratamiento de tus datos personales.',
    ourAddress: 'Nuestra dirección:',
    phoneLabel: 'Teléfono:',
    emailGeneralLabel: 'Email general:',
    whatData: '¿Qué información recopilamos?',
    whatDataIntro: 'Solo recopilamos la información necesaria para ofrecerte nuestros servicios profesionales. La cantidad y tipo de datos depende del servicio que solicites.',
    data1Title: '1. Datos básicos de identificación',
    data1What: 'Qué incluye:',
    data1WhatDesc: 'Nombre completo, documento de identidad, fecha de nacimiento, nacionalidad.',
    data1Why: 'Por qué los necesitamos:',
    data1WhyDesc: 'Son esenciales para prestarte servicios legales y administrativos en Suiza.',
    data2Title: '2. Información de contacto',
    data2WhatDesc: 'Dirección postal, teléfonos, email, contacto de emergencia.',
    data2WhyDesc: 'Para comunicarnos contigo y enviarte documentos importantes.',
    data3Title: '3. Datos profesionales y financieros',
    data3WhatDesc: 'Situación laboral, empresa, ingresos, documentos fiscales.',
    data3WhyDesc: 'Para gestiones administrativas, fiscales y de seguros.',
    data4Title: '4. Datos especiales (solo con tu permiso)',
    data4Important: 'Importante:',
    data4ImportantDesc: 'Solo tratamos datos sensibles con tu consentimiento expreso.',
    data4WhatDesc: 'Estado civil, datos de salud (para seguros médicos), información bancaria.',
    data4Control: 'Tu control:',
    data4ControlDesc: 'Puedes retirar este consentimiento en cualquier momento.',
    rightsTitle: '¿Cuáles son tus derechos?',
    rightsIntro: 'Como titular de datos personales, tienes derechos importantes que puedes ejercer en cualquier momento:',
    right1Title: 'Derecho a saber',
    right1Desc: 'Puedes solicitar información sobre qué datos tenemos, cómo los usamos y con quién los compartimos.',
    right2Title: 'Derecho a corregir',
    right2Desc: 'Si hay datos incorrectos o incompletos, puedes solicitar que los corrijamos de inmediato.',
    right3Title: 'Derecho al olvido',
    right3Desc: 'Puedes pedir que eliminemos tus datos cuando ya no sean necesarios (respetando obligaciones legales).',
    right4Title: 'Derecho a llevarte tus datos',
    right4Desc: 'Puedes recibir tus datos en formato digital para transferirlos a otro proveedor de servicios.',
    howExercise: '¿Cómo ejercer tus derechos?',
    howExerciseIntro: 'Es muy fácil. Puedes contactarnos por cualquiera de estos medios:',
    byEmail: 'Por email',
    byEmailWrite: 'Escribe a:',
    byEmailNote: 'Incluye copia de tu DNI',
    byPhone: 'Por teléfono',
    byPhoneCall: 'Llama al:',
    byPhoneNote: 'Horario de oficina',
    inPerson: 'Presencialmente',
    inPersonVisit: 'Visita nuestras oficinas',
    inPersonNote: 'Solicita cita previa',
    responseTime: 'Tiempo de respuesta:',
    responseTimeDesc: 'Te respondemos en máximo 30 días. Si el caso es complejo, podemos necesitar hasta 60 días, pero te avisaremos.',
    howProtect: '¿Cómo protegemos tu información?',
    securityMeasures: 'Medidas de seguridad',
    securityIntro: 'Implementamos las mejores medidas técnicas para proteger tus datos:',
    security1: 'Cifrado AES-256 para almacenamiento',
    security2: 'Comunicaciones seguras SSL/TLS',
    security3: 'Acceso restringido solo a personal autorizado',
    security4: 'Copias de seguridad encriptadas',
    security5: 'Formación regular del equipo en protección de datos',
    retention: '¿Cuánto tiempo guardamos tus datos?',
    retentionIntro: 'Solo conservamos tu información el tiempo necesario:',
    retention1Label: 'Documentos fiscales:',
    retention1Desc: '10 años (ley suiza)',
    retention2Label: 'Marketing:',
    retention2Desc: 'Hasta que retires consentimiento',
    retention3Label: 'Comunicaciones:',
    retention3Desc: '3 años desde última interacción',
    retention4Label: 'Datos web:',
    retention4Desc: 'Máximo 2 años',
    international: 'Transferencias internacionales',
    internationalDesc: 'Si necesitamos transferir datos fuera de Europa, solo lo hacemos a países con protección adecuada (como España) o a proveedores certificados en EE.UU., garantizando siempre tu protección.',
    questionsTitle: '¿Tienes dudas o quejas?',
    questionsIntro: 'Si tienes preguntas sobre esta política o cómo tratamos tus datos, contacta con nuestro Delegado de Protección de Datos:',
    emailLabel: 'Email:',
    complaintLabel: 'Derecho de reclamación:',
    complaintDesc: 'Si crees que no cumplimos con la normativa, puedes presentar una queja ante la Autoridad Federal de Protección de Datos de Suiza (FDPIC) o la autoridad de tu país de residencia.',
    lastUpdated: 'Última actualización:',
    lastUpdatedDate: '24 de junio de 2025',
    updateNote: 'Te notificaremos cualquier cambio importante en esta política',
  },

  // Hero homepage
  heroHome: {
    titleLine1: 'Deja de Sobrevivir.',
    titleLine2: 'Empieza a Vivir en Suiza.',
    subtitle: 'Sabemos lo que se siente estar perdido con los trámites. Recupera tu tranquilidad: nosotros nos encargamos de todo.',
    cta: 'Descubre Nuestras Soluciones',
    statFamilies: 'Familias Tranquilas',
    statFamiliesDesc: 'Ya resolvieron sus trámites',
    statYears: 'Años Resolviendo',
    statYearsDesc: 'Problemas reales como el tuyo',
    statAvailable: 'Siempre Disponibles',
    statAvailableDesc: 'Cuando nos necesites, aquí estamos',
    statSolutions: 'Soluciones',
    statSolutionsDesc: 'Para cada problema que enfrentas',
  },

  // Footer links
  footerLinks: {
    servicios: 'Servicios',
    gestoria: 'Gestoría',
    lifestyle: 'Lifestyle',
    empresa: 'Empresa',
    legal: 'Legal',
    gestoriaAdmin: 'Gestoría y Administración',
    asesoriaLegal: 'Asesoría Legal',
    formacionIdiomas: 'Formación en Idiomas',
    segurosPensiones: 'Seguros y Pensiones',
    desempleoRav: 'Desempleo (RAV)',
    administracion: 'Administración',
    cvDoc: 'CV y Documentación',
    acompanamientos: 'Acompañamientos',
    traducciones: 'Traducciones',
    paquetes: 'Paquetes Especiales',
    vehiculos: 'Alquiler de Vehículos',
    viviendas: 'Alquiler de Viviendas',
    packRelocation: 'Pack Relocation',
    solucionesDigitales: 'Soluciones Digitales',
    sobreNosotros: 'Sobre Nosotros',
    blog: 'Blog',
    contacto: 'Contacto',
    zonasServicio: 'Zonas de Servicio',
    privacidad: 'Política de Privacidad',
    avisoLegal: 'Aviso Legal',
    cookies: 'Política de Cookies',
    gdpr: 'GDPR',
    invalidEmail: 'Email inválido',
    errorRetry: 'Error. Inténtalo de nuevo.',
    followUs: 'Síguenos en',
  },

  // Navbar
  navbar: {
    tagline: 'Tu Gestoría y Asesoría en',
    contactUs: 'Contáctanos',
    closeMenu: 'Cerrar menú',
    openMenu: 'Abrir menú',
    myProfile: 'Mi Perfil',
    logout: 'Cerrar Sesión',
    login: 'Login',
  },

  // Shopping Cart
  cart: {
    title: 'Tu Carrito',
    emptyCart: 'Tu carrito está vacío',
    service: 'servicio',
    services: 'servicios',
    selected: 'seleccionados',
    clearCart: 'Vaciar carrito',
    limitedOffer: '¡Oferta Limitada!',
    addMoreServices: 'Añade más servicios y obtén descuentos exclusivos',
    numberOfPeople: 'Número de personas:',
    couponPlaceholder: 'Código de cupón',
    apply: 'Aplicar',
    subtotal: 'Subtotal:',
    persons: 'personas:',
    discount: 'Descuento:',
    total: 'Total:',
    continue: 'Continuar',
    backToCart: '← Volver al carrito',
    couponInvalid: 'Cupón no válido o expirado',
    couponExpired: 'Este cupón ha expirado',
    couponMaxUses: 'Este cupón ha alcanzado su límite de uso',
    couponMinPurchase: 'Compra mínima de {amount} CHF requerida',
    couponApplied: '¡Cupón aplicado!',
    couponDiscount: 'Descuento de {discount}',
    couponRemoved: 'Cupón eliminado',
    couponRemovedDesc: 'El descuento ha sido removido',
    couponError: 'Error al validar el cupón',
    serviceRemoved: 'Servicio eliminado',
    serviceRemovedDesc: '"{title}" ha sido eliminado del carrito',
    paymentMigration: 'Pagos en migración',
    paymentMigrationDesc: 'Estamos moviendo este checkout al nuevo panel integrado. Mientras tanto, contáctanos para finalizar tu solicitud.',
    paymentError: 'No se pudo continuar',
    paymentErrorDesc: 'Inténtalo de nuevo en unos momentos',
  },

  // Contact form
  contactForm: {
    fullName: 'Nombre completo',
    email: 'Email',
    phone: 'Teléfono',
    serviceArea: 'Área de servicio',
    selectService: 'Selecciona un servicio',
    message: 'Mensaje',
    messagePlaceholder: 'Describe tu consulta o proyecto...',
    characters: 'caracteres',
    send: 'Enviar mensaje',
    sending: 'Enviando...',
    formErrors: 'Errores en el formulario:',
    formErrorsDesc: 'Por favor, corrige los errores indicados.',
    tooManyAttempts: 'Demasiados intentos. Inténtalo de nuevo en {seconds} segundos.',
    submitError: 'Error al enviar el formulario. Inténtalo de nuevo.',
    successTitle: 'Mensaje enviado',
    successDesc: 'Gracias por contactarnos. Te responderemos pronto.',
    errorTitle: 'Error',
    errorDesc: 'Hubo un error al enviar el mensaje.',
    gestoriaOption: 'Gestoría y Administración',
    legalOption: 'Asesoría Legal',
    segurosOption: 'Seguros y Pensiones',
    idiomasOption: 'Cursos de Idiomas',
    digitalOption: 'Servicios Digitales',
    webOption: 'Diseño Web',
    crmOption: 'CRM',
    iaOption: 'Inteligencia Artificial',
    automationOption: 'Automatización',
    devOption: 'Desarrollo a Medida',
    generalOption: 'Consulta General',
    namePlaceholder: 'Tu nombre completo',
  },

  // Category components
  categoryHero: {
    requestInfo: 'Solicitar Información',
    meetTeam: 'Conoce nuestro equipo',
  },

  // Gestoria category page
  gestoriaCategoryPage: {
    specializedAgency: 'Gestoría Especializada',
    professionalService: 'Servicio profesional en español para hispanohablantes en Suiza.',
    freeConsultation: 'Consulta Gratuita',
    callNow: 'Llamar Ahora',
    clientsServed: 'Clientes atendidos',
    fastResponse: 'Respuesta rápida',
    inSpanish: 'En español',
    averageRating: 'Valoración media',
    servicesOf: 'Servicios de',
    finalPrices: 'Todos los precios son finales. Sin costes ocultos.',
    popular: 'Popular',
    add: 'Añadir',
    consult: 'Consultar',
    freeOrConsult: 'Servicio gratuito o consultar',
    freeOrConsultDesc: 'Contáctanos para más información sobre este servicio.',
    addedToCart: 'Añadido al carrito',
    howItWorks: '¿Cómo funciona?',
    step1: 'Contacto',
    step1Desc: 'Cuéntanos tu situación por WhatsApp o teléfono',
    step2: 'Documentación',
    step2Desc: 'Recopilamos toda la documentación necesaria',
    step3: 'Gestión',
    step3Desc: 'Realizamos todos los trámites por ti',
    step4: 'Resultado',
    step4Desc: 'Te entregamos todo completado y explicado',
    needHelp: '¿Necesitas ayuda con',
    firstFree: 'Primera consulta gratuita. Sin compromiso.',
    whatsapp: 'WhatsApp',
  },
  // Category components shared
  categoryFaq: { defaultTitle: 'Preguntas frecuentes' },
  categoryBlog: { defaultTitle: 'Artículos relacionados', viewAll: 'Ver todos los artículos', readMore: 'Leer más' },
  categoryContact: {
    defaultTitle: 'Contacta con nuestros expertos', defaultDesc: 'Solicita información o un presupuesto personalizado',
    preferDirect: '¿Prefieres hablar directamente?', teamAvailable: 'Nuestro equipo está disponible para resolver todas tus dudas por WhatsApp o programar una llamada.',
    formSent: '¡Formulario enviado!', formSentDesc: 'Gracias por contactar con nosotros. Un miembro de nuestro equipo se pondrá en contacto contigo lo antes posible.',
    sendAnother: 'Enviar otro mensaje', name: 'Nombre', namePlaceholder: 'Tu nombre completo', email: 'Email',
    phoneOptional: 'Teléfono (opcional)', serviceArea: 'Área de servicio', selectService: 'Selecciona un servicio',
    message: 'Mensaje', messagePlaceholder: 'Describe tu consulta en detalle', sending: 'Enviando...', send: 'Enviar mensaje',
    successTitle: 'Formulario enviado correctamente', successDesc: 'Nos pondremos en contacto contigo lo antes posible',
  },
  // Write Review Modal
  writeReview: {
    title: 'Escribe una reseña', whereToWrite: '¿Dónde te gustaría escribir tu reseña?',
    googleReview: 'Reseña en Google', googleDesc: 'Público, aparece en Google Maps',
    websiteReview: 'Reseña en nuestro sitio', websiteDesc: 'Aparece en nuestra web tras revisión',
    recommendGoogle: 'Recomendamos escribir también en Google para máxima visibilidad',
    redirectGoogle: 'Te redirigiremos a Google', redirectGoogleDesc: 'Serás llevado a Google Maps donde podrás escribir tu reseña pública.',
    goToGoogle: 'Ir a Google Maps', goBack: 'Volver atrás',
    nameLabel: 'Nombre *', emailLabel: 'Email *', ratingLabel: 'Calificación *', starsOf: 'de 5 estrellas',
    serviceUsed: 'Servicio utilizado', selectServicePlaceholder: 'Selecciona el servicio',
    reviewTitle: 'Título de la reseña', reviewTitlePlaceholder: 'Resumen de tu experiencia',
    yourReview: 'Tu reseña *', yourReviewPlaceholder: 'Cuéntanos sobre tu experiencia con nuestros servicios...',
    submitReview: 'Enviar reseña', submitting: 'Enviando...',
    reviewNote: '* Tu reseña será revisada antes de publicarse. También te invitamos a escribir en Google Maps.',
    requiredFields: 'Campos requeridos', requiredFieldsDesc: 'Por favor completa todos los campos obligatorios.',
    reviewSent: '¡Reseña enviada!', reviewSentDesc: 'Tu reseña será revisada antes de publicarse. ¡Gracias por tu feedback!',
    reviewError: 'No se pudo enviar la reseña. Inténtalo de nuevo.',
    gestoria: 'Gestoría', legal: 'Asesoría Legal', seguros: 'Seguros', idiomas: 'Formación en Idiomas',
    web: 'Desarrollo Web', crm: 'CRM y Automatización', general: 'Consulta General',
  },
  // Blog Newsletter
  blogNewsletter: {
    welcomeTitle: '¡Bienvenido a nuestra comunidad!', welcomeDesc: 'Recibirás nuestros mejores contenidos y consejos exclusivos en tu email',
    title: 'Newsletter Exclusivo para Hispanohablantes',
    subtitle: 'Recibe semanalmente guías prácticas, noticias fiscales y consejos legales para hispanohablantes en Suiza',
    exclusive: 'Contenido Exclusivo', exclusiveDesc: 'Guías no disponibles en el blog',
    legalUpdates: 'Actualizaciones Legales', legalUpdatesDesc: 'Cambios fiscales y legales en Suiza',
    weeklyTips: 'Tips Semanales', weeklyTipsDesc: 'Consejos prácticos cada semana',
    namePlaceholder: 'Tu nombre (opcional)', subscribing: 'Suscribiendo...', subscribe: 'Suscribirme Gratis',
    noSpam: 'No spam. Puedes darte de baja en cualquier momento.',
    invalidEmail: 'Email inválido', invalidEmailDesc: 'Por favor, introduce un email válido',
    successTitle: '¡Suscripción exitosa!', successDesc: 'Te hemos enviado un email de confirmación',
    errorTitle: 'Error', errorDesc: 'Hubo un problema con la suscripción. Inténtalo de nuevo.',
  },
  // Exit Intent Modal
  exitIntent: {
    defaultTitle: '¡Espera! Tenemos algo para ti',
    defaultDesc: 'Antes de irte, déjanos tu email y recibe una consulta gratuita de 15 minutos',
    defaultOffer: 'Consulta gratuita', submit: 'Quiero mi consulta gratis',
    sending: 'Enviando...', thanks: '¡Gracias! Te contactaremos pronto',
    error: 'Error al enviar. Inténtalo de nuevo', dismiss: 'No gracias, continuar navegando',
  },
  // Contact Form Inline
  contactInline: {
    nameFull: 'Nombre completo', namePlaceholder: 'Tu nombre', email: 'Email',
    phoneOptional: 'Teléfono (opcional)', serviceInterest: 'Servicio que te interesa',
    selectService: 'Selecciona un servicio', gestoria: 'Gestoría y Administración', legal: 'Asesoría Legal',
    idiomas: 'Formación en Idiomas', seguros: 'Seguros y Pensiones', digital: 'Soluciones Digitales',
    coches: 'Alquiler de Coches', viviendas: 'Alquiler de Viviendas', relocation: 'Pack Relocation',
    orientacion: 'No estoy seguro/a — necesito orientación',
    whatWorries: '¿Qué te preocupa?', tellUs: 'Cuéntanos brevemente tu situación...',
    sending: 'Enviando...', sendFree: 'Enviar mi Consulta Gratis',
    dataPrivacy: '🔒 Tus datos son confidenciales. No compartimos tu información con terceros.',
    sentTitle: '¡Mensaje Enviado!', sentDesc: 'Te respondemos en un máximo de 2 horas en horario laboral.',
    sendAnother: 'Enviar otro mensaje', successTitle: '¡Mensaje enviado!', successDesc: 'Te respondemos en menos de 2 horas.',
    errorTitle: 'Error al enviar', errorDesc: 'Hubo un problema. Por favor intenta nuevamente.',
  },
  // Home Featured Services
  homeFeatured: {
    kicker: 'Servicios destacados', deliveredThisYear: 'servicios entregados este año',
    title: 'Servicios profesionales en Suiza para hispanohablantes',
    subtitle: 'Gestoría, asesoría legal y transformación digital, todo en su idioma',
    desc: 'Optimice impuestos, regularice su situación y haga crecer su negocio con un solo equipo',
    viewAll: 'Ver Todos los Servicios',
    gestoria: 'Gestoría Fiscal', gestoriaDesc: 'Asesoramiento fiscal personalizado para particulares y empresas en Suiza.',
    gestoriaBtn: 'Ver servicios de gestoría',
    legal: 'Asesoría Legal', legalDesc: 'Servicio legal especializado para la comunidad hispanohablante en Suiza.',
    legalBtn: 'Ver servicios legales',
    digital: 'Soluciones Digitales', digitalDesc: 'Transformación digital para impulsar y modernizar su negocio.',
    digitalBtn: 'Ver soluciones digitales',
    feat1: 'Declaraciones de impuestos', feat2: 'Planificación fiscal', feat3: 'Gestión contable', feat4: 'Optimización tributaria',
    feat5: 'Extranjería y residencia', feat6: 'Contratos laborales', feat7: 'Derecho de familia', feat8: 'Asesoría inmobiliaria',
    feat9: 'Diseño web profesional', feat10: 'Sistemas CRM personalizados', feat11: 'Automatización de procesos', feat12: 'Marketing digital efectivo',
  },
  // Home Stats
  homeStats: {
    title: 'Resultados que inspiran confianza', updated: 'Actualizado 2025',
    clients: 'Clientes Satisfechos', clientsDesc: 'Confiaron en nosotros',
    procedures: 'Trámites Completados', proceduresDesc: 'Resolución exitosa',
    companies: 'Empresas Creadas', companiesDesc: 'En toda Suiza',
    experience: 'Años de Experiencia', experienceDesc: 'Servicio continuado',
  },
  // Home Testimonials
  homeTestimonials: {
    title: 'Lo Que Dicen Nuestros Clientes', subtitle: 'Reseñas reales de clientes satisfechos con nuestros servicios',
    basedOn: 'Basado en 50+ reseñas de Google', verified: 'Verificado', googleReview: 'Reseña de Google',
    viewAll: 'Ver todas las reseñas', leaveReview: 'Déjanos tu reseña',
    usedServices: '¿Has utilizado nuestros servicios? Tu opinión es muy importante para nosotros.',
  },
  // Servicios Section
  serviciosSection: {
    title: 'Servicios', titleAccent: 'clave para tu vida en Suiza',
    subtitle: 'Todo en un solo lugar, sin barreras lingüísticas.',
    gestoria: 'Gestoría y Administración', gestoriaDesc: 'Impuestos y contabilidad sin complicaciones.',
    legal: 'Asesoría Legal', legalDesc: 'Extranjería, trabajo y familia con abogados bilingües.',
    idiomas: 'Cursos de Alemán', idiomasDesc: 'Avanza desde la primera semana.',
    seguros: 'Seguros y 3er Pilar', segurosDesc: 'Comparación independiente. Ahorro real.',
    digital: 'Soluciones Digitales', digitalDesc: 'Web + CRM + IA para crecer en Suiza.',
    coches: 'Alquiler de Coches', cochesDesc: 'Entrega flexible, todo riesgo, en español.',
    viviendas: 'Alquiler de Viviendas', viviendasDesc: 'Te conseguimos visitas y contrato, tú eliges.',
    relocation: 'Pack Relocation', relocationDesc: 'Llegas y nosotros resolvemos todo en 30 días.',
    bestSeller: 'Más vendido 🔥', forHispanics: 'Especial hispanohablantes', save25: 'Ahorra hasta 25%', allInclusive: 'Todo incluido ✅',
    learnMore: 'Saber más', customSolution: '¿Necesitas una solución personalizada?',
    customDesc: 'Contacta con nuestros expertos para una consulta gratuita y descubre cómo podemos ayudarte a hacer crecer tu negocio.',
    enterBtn: 'Entrar', creating: 'Creando cuenta...', createBtn: 'Crear cuenta',
    trustClients: 'Clientes satisfechos', trustResponse: 'Tiempo de respuesta', trustResponseValue: '< 2 horas',
    trustLanguages: 'Idiomas', trustLanguagesValue: 'ES, DE, EN',
  },
  // Reset Password
  resetPassword: {
    seoTitle: 'Nueva Contraseña - Punto Hispano', seoDesc: 'Establece tu nueva contraseña',
    successSeoTitle: 'Contraseña Actualizada - Punto Hispano', successSeoDesc: 'Tu contraseña ha sido actualizada',
    invalidLink: 'Enlace inválido o expirado', invalidLinkDesc: 'Por favor solicita un nuevo enlace de recuperación',
    passwordMin: 'La contraseña debe tener al menos 8 caracteres',
    mismatch: 'Las contraseñas no coinciden', mismatchDesc: 'Por favor verifica que ambas contraseñas sean iguales',
    tooShort: 'Contraseña muy corta', tooShortDesc: 'La contraseña debe tener al menos 8 caracteres',
    successTitle: '¡Contraseña actualizada!', successDesc: 'Tu contraseña ha sido cambiada exitosamente',
    successRedirect: 'Tu contraseña ha sido cambiada exitosamente. Serás redirigido automáticamente...',
    goToClient: 'Ir al área cliente', newPassword: 'Nueva Contraseña', enterNew: 'Ingresa tu nueva contraseña para continuar',
    newPasswordLabel: 'Nueva contraseña', minChars: 'Mínimo 8 caracteres',
    confirmPassword: 'Confirmar contraseña', repeatPassword: 'Repite tu contraseña',
    updating: 'Actualizando...', changePassword: 'Cambiar contraseña',
    errorTitle: 'Error al cambiar contraseña', errorDesc: 'Hubo un problema cambiando tu contraseña',
  },

  // Contact Form Page
  contactFormPage: {
    seoTitle: 'Formulario de Contacto | Punto Hispano',
    seoDesc: 'Contáctenos para consultas sobre nuestros servicios para la comunidad hispanohablante en Suiza.',
    title: 'Formulario de Contacto',
    subtitle: 'Complete el formulario a continuación para enviarnos su consulta. Nuestro equipo se pondrá en contacto con usted lo antes posible.',
    successTitle: '¡Mensaje Enviado!',
    successDesc: 'Gracias por contactarnos. Hemos recibido su mensaje y nos pondremos en contacto con usted lo más pronto posible, normalmente en un plazo de 24-48 horas laborables.',
    sendAnother: 'Enviar otro mensaje',
    labelName: 'Nombre completo',
    placeholderName: 'Ingrese su nombre',
    labelEmail: 'Correo electrónico',
    placeholderEmail: 'nombre@ejemplo.com',
    labelPhone: 'Teléfono (opcional)',
    placeholderPhone: 'Su número de teléfono',
    labelServiceArea: 'Área de servicio',
    selectArea: 'Seleccione un área',
    optGestoria: 'Gestoría y Administración',
    optLegal: 'Asesoría Legal',
    optIdiomas: 'Formación en Idiomas',
    optSeguros: 'Seguros y Pensiones',
    optDigital: 'Soluciones Digitales',
    optCoches: 'Alquiler de Coches',
    optViviendas: 'Alquiler de Viviendas',
    labelMessage: 'Mensaje',
    placeholderMessage: '¿En qué podemos ayudarle?',
    submitBtn: 'Enviar Mensaje',
    sending: 'Enviando...',
    toastSuccess: 'Formulario enviado',
    toastSuccessDesc: 'Hemos recibido su mensaje y nos pondremos en contacto pronto.',
    toastError: 'Error al enviar',
    toastErrorDesc: 'Hubo un problema al enviar su mensaje. Por favor intente nuevamente.',
    privacyNote: 'Al enviar este formulario, acepta nuestra',
    privacyLink: 'política de privacidad',
    privacyNote2: 'y el tratamiento de sus datos para responder a su consulta.',
    fastResponse: 'Respuesta rápida',
    fastResponseDesc: '24-48h laborables',
    noCommitment: 'Consulta sin compromiso',
    noCommitmentDesc: 'Presupuestos personalizados',
    spanishSupport: 'Atención en español',
    spanishSupportDesc: 'Equipo 100% hispanohablante',
    validationName: 'El nombre debe tener al menos 2 caracteres',
    validationEmail: 'Por favor ingrese un correo electrónico válido',
    validationService: 'Por favor seleccione un área de servicio',
    validationMessage: 'El mensaje debe tener al menos 10 caracteres',
    interestedIn: 'Estoy interesado en información sobre los servicios de',
  },

  // Service Subpage Templates - shared UI chrome
  serviceTemplates: {
    freeWhatsapp: 'Consulta Gratis por WhatsApp',
    askWhatsapp: 'Pedir Información por WhatsApp',
    whatsappDirect: 'WhatsApp Directo',
    notSure: '¿No estás seguro de qué necesitas? Escríbenos y te orientamos gratis.',
    backTo: 'Volver a',
    popular: 'Popular',
    bestSeller: 'Más Vendido',
    allIncluded: 'Todo Incluido',
    free: 'Gratis',
    servicesAvailable: 'servicios disponibles',
    serviceAvailable: 'servicio disponible',
    packagesAvailable: 'paquetes disponibles',
    packageAvailable: 'paquete disponible',
    whichForYou: '¿Cuál Es Para Ti?',
    freeConsultation: 'Consulta Gratis por WhatsApp',
    // Gestoría
    gestoriaBreadcrumb: 'Gestoría',
    // Legal
    legalBreadcrumb: 'Legal',
    legalFreeConsult: 'Consulta Gratis por WhatsApp',
    legalNotSure: '¿No estás seguro de qué necesitas? Te orientamos gratis.',
    legalWaCard: 'Hola, necesito asesoría legal sobre {name}.',
    legalWaGuidance: 'Hola, necesito orientación sobre qué servicio legal necesito.',
    // Seguros
    segurosBreadcrumb: 'Seguros y Pensiones',
    segurosInsured: '+20.000 personas aseguradas en 5 años',
    segurosServiceName: 'Seguros y Pensiones',
    segurosWaCard: 'Hola, me interesa el servicio de {name}.',
    segurosWaHero: 'Hola, necesito información sobre {name}.',
    segurosWaGuidance: 'Hola, necesito orientación sobre seguros.',
    // Relocation
    relocationBreadcrumb: 'Pack Relocation',
    relocationNeedHelp: 'Hola, necesito orientación sobre el Pack Relocation.',
  },
  // Cookie Banner
  cookieBanner: {
    title: 'Cookies',
    description: 'Usamos cookies para mejorar tu experiencia.',
    moreInfo: 'Más info',
    adjust: 'Ajustar',
    reject: 'Rechazar',
    accept: 'Aceptar',
    preferences: 'Preferencias',
    necessary: 'Necesarias',
    functional: 'Funcionales',
    analytics: 'Análisis',
    marketing: 'Marketing',
    required: 'requerida',
    onlyNecessary: 'Solo necesarias',
    save: 'Guardar',
  },
  // Section Navigation (progress dots)
  sectionNav: {
    home: 'Inicio',
    services: 'Servicios',
    about: 'Nosotros',
    process: 'Proceso',
    testimonials: 'Testimonios',
    faq: 'FAQ',
    contact: 'Contacto',
  },
  // Help Widget
  helpWidget: {
    help: '¿Ayuda?',
    assistant: 'Asistente',
    minimize: 'Minimizar widget de ayuda',
    howCanWeHelp: '¿CÓMO PODEMOS AYUDARTE?',
    online: 'Estamos online',
    closeMenu: 'Cerrar menú de ayuda',
    aiChat: 'CHAT CON IA',
    aiChatDesc: 'Respuesta instantánea 24/7',
  },
};

export default es;
export type TranslationKeys = typeof es;

